var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/facts/address.facts.ts
(function(AddressFacts2) {
  function linesToString(address) {
    const { line1, line2, line3, line4 } = address;
    const lines = [
      line1,
      line2,
      line3,
      line4
    ].filter((part) => part !== void 0);
    if (lines.length === 0) {
      return "<unknown>";
    }
    return lines.join(", ");
  }
  __name(linesToString, "linesToString");
  AddressFacts2.linesToString = linesToString;
  function toString(address) {
    const addressParts = [
      linesToString(address),
      address.locality,
      address.region,
      address.postcode,
      address.country?.id
    ];
    return addressParts.filter(Boolean).join(", ").trim();
  }
  __name(toString, "toString");
  AddressFacts2.toString = toString;
  function equals(left, right) {
    return toString(left).toLowerCase() === toString(right).toLowerCase();
  }
  __name(equals, "equals");
  AddressFacts2.equals = equals;
})(AddressFacts || (AddressFacts = {}));
var AddressFacts;

// src/facts/bundle.facts.ts
(function(BundleFacts2) {
  function isRootBundle(bundle) {
    return bundle.id === bundle.rootBundleId;
  }
  __name(isRootBundle, "isRootBundle");
  BundleFacts2.isRootBundle = isRootBundle;
})(BundleFacts || (BundleFacts = {}));
var BundleFacts;

// src/facts/campaign.facts.ts
(function(CampaignFacts2) {
  function isDefaultCampaign(campaign) {
    return campaign.endDate === void 0;
  }
  __name(isDefaultCampaign, "isDefaultCampaign");
  CampaignFacts2.isDefaultCampaign = isDefaultCampaign;
})(CampaignFacts || (CampaignFacts = {}));
var CampaignFacts;

// src/facts/claim.facts.ts
import Decimal from "decimal.js";
import { BaggageDisruptionTypes, ClaimStatusEnum, FlightStatusEnum, ProductCompensationSettingPropertyEnum as ProductCompensationSettingPropertyEnum2, ProductTypeEnum } from "@repo/lib-koala-types";
import { roundPrice } from "@repo/lib-utils";

// src/facts/compensation-settings.facts.ts
import { PriceSettingTypeEnum, ProductCompensationSettingPropertyEnum } from "@repo/lib-koala-types";
import { numberDescendingSorter } from "@repo/lib-utils";
var NoCoefficientCompensationSettingForCurrency = class extends Error {
  static {
    __name(this, "NoCoefficientCompensationSettingForCurrency");
  }
  constructor(compensationSettings) {
    super(`No coefficient-based compensation setting found in the provided settings: ${JSON.stringify(compensationSettings)}.`);
  }
};
function valueAsNumber(value) {
  return typeof value === "number" ? value : value.toNumber();
}
__name(valueAsNumber, "valueAsNumber");
function valueDescendingSorter(a, b) {
  return numberDescendingSorter(valueAsNumber(a.value), valueAsNumber(b.value));
}
__name(valueDescendingSorter, "valueDescendingSorter");
(function(CompensationSettingsFacts2) {
  function getSettingsForCurrency(compensationSettings, currency) {
    const settingsForCurrency = compensationSettings.filter(({ currencyId }) => !currencyId || currencyId === currency.id);
    if (settingsForCurrency.length === 0) {
      throw new Error(`No compensation setting for currency: "${currency.id}".`);
    }
    return settingsForCurrency;
  }
  __name(getSettingsForCurrency, "getSettingsForCurrency");
  CompensationSettingsFacts2.getSettingsForCurrency = getSettingsForCurrency;
  function getCoefficientSettings(compensationSettings) {
    const coefficientSettings = compensationSettings.filter((setting) => setting.type === PriceSettingTypeEnum.COEFFICIENT && setting.coefficientProperty !== null);
    if (coefficientSettings.length === 0) {
      throw new NoCoefficientCompensationSettingForCurrency(compensationSettings);
    }
    return coefficientSettings;
  }
  __name(getCoefficientSettings, "getCoefficientSettings");
  CompensationSettingsFacts2.getCoefficientSettings = getCoefficientSettings;
  function getSettingWithHighestValue(compensationSettings) {
    if (compensationSettings.length === 0) {
      throw new Error("The provided list of compensation settings is empty.");
    }
    return compensationSettings.sort(valueDescendingSorter).at(0);
  }
  __name(getSettingWithHighestValue, "getSettingWithHighestValue");
  CompensationSettingsFacts2.getSettingWithHighestValue = getSettingWithHighestValue;
  function getHighestCoefficientSetting(compensationSettings, currency) {
    const compensationSettingsForCurrency = getSettingsForCurrency(compensationSettings, currency);
    const coefficientSettings = getCoefficientSettings(compensationSettingsForCurrency);
    if (coefficientSettings.length === 1) {
      return coefficientSettings[0];
    }
    return coefficientSettings.sort(valueDescendingSorter).at(0);
  }
  __name(getHighestCoefficientSetting, "getHighestCoefficientSetting");
  CompensationSettingsFacts2.getHighestCoefficientSetting = getHighestCoefficientSetting;
  function hasOneCancellationFeesSetting(settings, currency) {
    const settingsToEvaluate = currency ? CompensationSettingsFacts2.getSettingsForCurrency(settings, currency) : settings;
    return settingsToEvaluate.some((setting) => setting.type === PriceSettingTypeEnum.COEFFICIENT && setting.coefficientProperty === ProductCompensationSettingPropertyEnum.CANCELLATION_FEES);
  }
  __name(hasOneCancellationFeesSetting, "hasOneCancellationFeesSetting");
  CompensationSettingsFacts2.hasOneCancellationFeesSetting = hasOneCancellationFeesSetting;
  function getHighestSettingCoveringDisruption(compensationSettings, currency, disruptionType) {
    const settingsForCurrency = getSettingsForCurrency(compensationSettings, currency);
    const settingsForLoss = settingsForCurrency.filter((cs) => cs.conditions !== void 0).filter((cs) => JSON.stringify(cs.conditions).includes(JSON.stringify({
      in: [
        disruptionType,
        {
          var: "events"
        }
      ]
    })));
    if (settingsForLoss.length === 0) {
      return null;
    }
    if (settingsForLoss.length === 1) {
      return settingsForLoss[0];
    }
    return settingsForLoss.sort(valueDescendingSorter)[0];
  }
  __name(getHighestSettingCoveringDisruption, "getHighestSettingCoveringDisruption");
  CompensationSettingsFacts2.getHighestSettingCoveringDisruption = getHighestSettingCoveringDisruption;
})(CompensationSettingsFacts || (CompensationSettingsFacts = {}));
var CompensationSettingsFacts;

// src/facts/claim.facts.ts
function withNonRefundableTripPriceFallback(context, settings) {
  const usesNonRefundableTripPrice = settings.some((setting) => setting.coefficientProperty === ProductCompensationSettingPropertyEnum2.NON_REFUNDABLE_TRIP_PRICE);
  if (!usesNonRefundableTripPrice || context[ProductCompensationSettingPropertyEnum2.NON_REFUNDABLE_TRIP_PRICE] !== void 0 || !Decimal.isDecimal(context[ProductCompensationSettingPropertyEnum2.TARGET_PRICE])) {
    return context;
  }
  return {
    ...context,
    [ProductCompensationSettingPropertyEnum2.NON_REFUNDABLE_TRIP_PRICE]: context[ProductCompensationSettingPropertyEnum2.TARGET_PRICE]
  };
}
__name(withNonRefundableTripPriceFallback, "withNonRefundableTripPriceFallback");
function computeBaseCompensation(compensationSetting, numberOfTravelers) {
  const settingValue = new Decimal(compensationSetting.value);
  if (!compensationSetting.maximumValue) {
    return settingValue.mul(numberOfTravelers);
  }
  if (!compensationSetting.maxValueAppliesPerTraveler) {
    return Decimal.min(compensationSetting.maximumValue, settingValue.mul(numberOfTravelers));
  }
  return Decimal.min(compensationSetting.maximumValue, compensationSetting.value).mul(numberOfTravelers);
}
__name(computeBaseCompensation, "computeBaseCompensation");
function getCompensationBasedOnHighestSetting(compensationSettings, currency, context) {
  const maximumCompensationSetting = CompensationSettingsFacts.getSettingWithHighestValue(compensationSettings);
  const compensation = computeBaseCompensation(maximumCompensationSetting, context.numberOfTravelers);
  return roundPrice(compensation, currency.legalExponentPrecision);
}
__name(getCompensationBasedOnHighestSetting, "getCompensationBasedOnHighestSetting");
function computeCoefficientCompensation(compensationSetting, currency, context) {
  const compensationCalculationBase = context ? context[compensationSetting.coefficientProperty] : null;
  if (!compensationCalculationBase || !Decimal.isDecimal(compensationCalculationBase)) {
    throw new Error(`No property "${compensationSetting.coefficientProperty}" in context "${JSON.stringify(context)}", or property is not a number.`);
  }
  const baseCompensation = compensationCalculationBase.mul(compensationSetting.value);
  if (!compensationSetting.maximumValue) {
    return baseCompensation;
  }
  if (!compensationSetting.maxValueAppliesPerTraveler) {
    return Decimal.min(baseCompensation, compensationSetting.maximumValue);
  }
  if (!context?.numberOfTravelers) {
    throw new Error("Unable to compute the maximum compensation without the number of travelers.");
  }
  const maximumCompensation = new Decimal(compensationSetting.maximumValue).mul(context.numberOfTravelers);
  const compensation = Decimal.min(baseCompensation, maximumCompensation);
  return roundPrice(compensation, currency.legalExponentPrecision);
}
__name(computeCoefficientCompensation, "computeCoefficientCompensation");
function getFlightDisruptionCompensation(compensationSettings, currency, context) {
  if (context?.flightStatus === void 0) {
    throw new Error(`No property "flightStatus" in context "${JSON.stringify(context)}".`);
  }
  const settingsForCurrency = CompensationSettingsFacts.getSettingsForCurrency(compensationSettings, currency);
  if ([
    FlightStatusEnum.CANCELED,
    FlightStatusEnum.DIVERTED,
    FlightStatusEnum.LANDED
  ].includes(context.flightStatus)) {
    return getCompensationBasedOnHighestSetting(settingsForCurrency, currency, context);
  }
  throw new Error(`No compensation for flight with status ${context.flightStatus}.`);
}
__name(getFlightDisruptionCompensation, "getFlightDisruptionCompensation");
function getMaximumCoefficientCompensation(settings, currency, context) {
  const settingWithHighestCoefficient = CompensationSettingsFacts.getHighestCoefficientSetting(settings, currency);
  const compensation = computeCoefficientCompensation(settingWithHighestCoefficient, currency, context);
  return roundPrice(compensation, currency.legalExponentPrecision);
}
__name(getMaximumCoefficientCompensation, "getMaximumCoefficientCompensation");
function getChangeForAnyReasonCompensation(compensationSettings, currency, context) {
  const maximumCompensation = getMaximumCoefficientCompensation(compensationSettings, currency, context);
  if (context?.refundableAmount === void 0) {
    throw new Error(`No property "refundableAmount" in context: "${JSON.stringify(context)}".`);
  }
  const compensation = Decimal.min(context.refundableAmount, maximumCompensation);
  return roundPrice(compensation, currency.legalExponentPrecision);
}
__name(getChangeForAnyReasonCompensation, "getChangeForAnyReasonCompensation");
function getCoefficientBasedCompensation(compensationSettings, currency, context) {
  const coefficientSettings = CompensationSettingsFacts.getCoefficientSettings(compensationSettings);
  if (coefficientSettings.length !== 1) {
    throw new Error(`There should only be 1 coefficient-based compensation setting: ${JSON.stringify(coefficientSettings)}.`);
  }
  const coefficientCompensation = computeCoefficientCompensation(coefficientSettings[0], currency, context);
  const compensation = context.refundableAmount !== void 0 ? Decimal.min(context.refundableAmount, coefficientCompensation) : coefficientCompensation;
  return roundPrice(compensation, currency.legalExponentPrecision);
}
__name(getCoefficientBasedCompensation, "getCoefficientBasedCompensation");
function getBdcMaximumCompensation(settingsForCurrency, currency, context) {
  const { numberOfCheckedBags } = context;
  if (numberOfCheckedBags === void 0) {
    throw new Error(`No property "numberOfCheckedBags" in context "${JSON.stringify(context)}".`);
  }
  const settingWithHighestValue = CompensationSettingsFacts.getSettingWithHighestValue(settingsForCurrency);
  const settingCoveringLoss = CompensationSettingsFacts.getHighestSettingCoveringDisruption(settingsForCurrency, currency, BaggageDisruptionTypes.BAGGAGE_LOSS);
  const settingToUse = settingCoveringLoss ?? settingWithHighestValue;
  const baseMaximumCompensation = settingToUse.value.mul(numberOfCheckedBags);
  if (settingToUse.maximumValue === null) {
    return roundPrice(baseMaximumCompensation, currency.legalExponentPrecision);
  }
  const isMaxValueAppliedPerBag = settingWithHighestValue.maxValueAppliesPerBag ?? false;
  if (isMaxValueAppliedPerBag === true) {
    const maximumValue = new Decimal(settingToUse.maximumValue).mul(numberOfCheckedBags);
    const maximumCompensation2 = Decimal.min(baseMaximumCompensation, maximumValue);
    return roundPrice(maximumCompensation2, currency.legalExponentPrecision);
  }
  const maximumCompensation = Decimal.min(baseMaximumCompensation, settingToUse.maximumValue);
  return roundPrice(maximumCompensation, currency.legalExponentPrecision);
}
__name(getBdcMaximumCompensation, "getBdcMaximumCompensation");
function getBdcCompensation(settingsForCurrency, currency, context) {
  const { baggageDisruptions } = context;
  if (baggageDisruptions === void 0) {
    throw new Error(`No property "baggageDisruptions" in context "${JSON.stringify(context)}".`);
  }
  if (baggageDisruptions.length === 0) {
    throw new Error(`The list of baggage disruptions is context is empty: "${JSON.stringify(context)}".`);
  }
  const totalCompensation = baggageDisruptions.map((disruption) => {
    const setting = CompensationSettingsFacts.getHighestSettingCoveringDisruption(settingsForCurrency, currency, disruption.type);
    if (setting === null) {
      throw new Error(`No compensation setting covering "${disruption.type}" was found.`);
    }
    const compensation = setting.value.mul(disruption.numberOfAffectedBags);
    if (setting.maximumValue === null) {
      return compensation;
    }
    const isMaxValueAppliedPerBag = setting.maxValueAppliesPerBag ?? false;
    if (isMaxValueAppliedPerBag === true) {
      const maximumValue = new Decimal(setting.maximumValue).mul(disruption.numberOfAffectedBags);
      return Decimal.min(compensation, maximumValue);
    }
    return Decimal.min(compensation, setting.maximumValue);
  }).reduce((acc, curr) => acc.plus(curr), new Decimal(0));
  return roundPrice(totalCompensation, currency.legalExponentPrecision);
}
__name(getBdcCompensation, "getBdcCompensation");
(function(ClaimFacts2) {
  ClaimFacts2.eligibleClaimStatuses = [
    ClaimStatusEnum.REFUNDABLE,
    ClaimStatusEnum.REFUNDED,
    ClaimStatusEnum.ACCEPTED,
    ClaimStatusEnum.MANUAL_VERIFICATION_NEEDED,
    ClaimStatusEnum.REFUND_ERROR
  ];
  function isEligibleClaimStatus(status) {
    return ClaimFacts2.eligibleClaimStatuses.includes(status);
  }
  __name(isEligibleClaimStatus, "isEligibleClaimStatus");
  ClaimFacts2.isEligibleClaimStatus = isEligibleClaimStatus;
  function getMaximumCompensation(compensationSettings, currency, productType, context) {
    if (productType === ProductTypeEnum.COMPREHENSIVE) {
      return new Decimal(0);
    }
    const settingsForCurrency = CompensationSettingsFacts.getSettingsForCurrency(compensationSettings, currency);
    switch (productType) {
      case ProductTypeEnum.FLIGHT_DISRUPTION:
        return getCompensationBasedOnHighestSetting(settingsForCurrency, currency, context);
      case ProductTypeEnum.WITHDRAWAL:
      case ProductTypeEnum.CHANGE_FOR_ANY_REASON:
      case ProductTypeEnum.CANCELLATION_WITHOUT_PROOF:
        return getMaximumCoefficientCompensation(settingsForCurrency, currency, withNonRefundableTripPriceFallback(context, settingsForCurrency));
      case ProductTypeEnum.BAGGAGE_DISRUPTION:
        return getBdcMaximumCompensation(settingsForCurrency, currency, context);
      default:
        throw new Error(`Unable to get the highest compensation amount because the product type "${productType}" is unsupported.`);
    }
  }
  __name(getMaximumCompensation, "getMaximumCompensation");
  ClaimFacts2.getMaximumCompensation = getMaximumCompensation;
  function getCompensation(compensationSettings, currency, productType, context) {
    const settingsForCurrency = CompensationSettingsFacts.getSettingsForCurrency(compensationSettings, currency);
    switch (productType) {
      case ProductTypeEnum.FLIGHT_DISRUPTION:
        return getFlightDisruptionCompensation(settingsForCurrency, currency, context);
      case ProductTypeEnum.WITHDRAWAL:
      case ProductTypeEnum.CANCELLATION_WITHOUT_PROOF:
        return getCoefficientBasedCompensation(settingsForCurrency, currency, context);
      case ProductTypeEnum.CHANGE_FOR_ANY_REASON:
        return getChangeForAnyReasonCompensation(settingsForCurrency, currency, context);
      case ProductTypeEnum.BAGGAGE_DISRUPTION:
        return getBdcCompensation(settingsForCurrency, currency, context);
      case ProductTypeEnum.COMPREHENSIVE:
      default:
        throw new Error(`Unable to compute compensation amount because the product type "${productType}" is unsupported.`);
    }
  }
  __name(getCompensation, "getCompensation");
  ClaimFacts2.getCompensation = getCompensation;
  ClaimFacts2.getBaseCompensation = computeBaseCompensation;
})(ClaimFacts || (ClaimFacts = {}));
var ClaimFacts;

// src/facts/contract.facts.ts
import { Duration } from "luxon";
import { CoveredEventTypeEnum as CoveredEventTypeEnum4, ProductTypeEnum as ProductTypeEnum3 } from "@repo/lib-koala-types";

// src/facts/trip.facts.ts
import _5 from "lodash";
import { DateTime as DateTime2 } from "luxon";
import { CoveredEventTypeEnum as CoveredEventTypeEnum3 } from "@repo/lib-koala-types";
import { isNotUndefined } from "@repo/lib-typing";
import { dateTimeAscendingSorter as dateTimeAscendingSorter4 } from "@repo/lib-utils";

// src/facts/journey.facts.ts
import _3 from "lodash";
import { DateTime } from "luxon";
import { dateTimeAscendingSorter as dateTimeAscendingSorter2 } from "@repo/lib-utils";

// src/facts/segment.facts.ts
import _2 from "lodash";
import { RouteModeEnum } from "@repo/lib-koala-types";
import { dateTimeAscendingSorter } from "@repo/lib-utils";

// src/facts/flight.facts.ts
import _ from "lodash";
import { CoveredEventTypeEnum as CoveredEventTypeEnum2 } from "@repo/lib-koala-types";

// src/facts/product.facts.ts
import { CoveredEventTypeEnum, ProductTypeEnum as ProductTypeEnum2 } from "@repo/lib-koala-types";
(function(ProductFacts2) {
  ProductFacts2.COVERED_EVENT_COMPATIBILITY_MAP = {
    [ProductTypeEnum2.CHANGE_FOR_ANY_REASON]: [
      CoveredEventTypeEnum.TRIP
    ],
    [ProductTypeEnum2.COMPREHENSIVE]: [
      CoveredEventTypeEnum.TRIP
    ],
    [ProductTypeEnum2.WITHDRAWAL]: [
      CoveredEventTypeEnum.FLIGHT,
      CoveredEventTypeEnum.TRIP
    ],
    [ProductTypeEnum2.FLIGHT_DISRUPTION]: [
      CoveredEventTypeEnum.FLIGHT
    ],
    [ProductTypeEnum2.CANCELLATION_WITHOUT_PROOF]: [
      CoveredEventTypeEnum.TRIP
    ],
    [ProductTypeEnum2.BAGGAGE_DISRUPTION]: [
      CoveredEventTypeEnum.TRIP
    ]
  };
  ProductFacts2.INSURANCE_PRODUCTS_MAPPING = {
    [ProductTypeEnum2.WITHDRAWAL]: false,
    [ProductTypeEnum2.CHANGE_FOR_ANY_REASON]: false,
    [ProductTypeEnum2.COMPREHENSIVE]: true,
    [ProductTypeEnum2.FLIGHT_DISRUPTION]: true,
    [ProductTypeEnum2.CANCELLATION_WITHOUT_PROOF]: true,
    [ProductTypeEnum2.BAGGAGE_DISRUPTION]: true
  };
  function isInsuranceProduct2(productType) {
    return ProductFacts2.INSURANCE_PRODUCTS_MAPPING[productType];
  }
  __name(isInsuranceProduct2, "isInsuranceProduct");
  ProductFacts2.isInsuranceProduct = isInsuranceProduct2;
})(ProductFacts || (ProductFacts = {}));
var ProductFacts;

// src/facts/flight.facts.ts
(function(FlightFacts2) {
  function getCompatibleProductTypes() {
    return Object.entries(ProductFacts.COVERED_EVENT_COMPATIBILITY_MAP).reduce((acc, [productType, coveredEventTypes]) => {
      if (coveredEventTypes.includes(CoveredEventTypeEnum2.FLIGHT)) {
        acc.push(productType);
      }
      return acc;
    }, new Array());
  }
  __name(getCompatibleProductTypes, "getCompatibleProductTypes");
  FlightFacts2.getCompatibleProductTypes = getCompatibleProductTypes;
  function getFlightUniqueIdentifierProperties(flight) {
    return {
      ..._.pick(flight, [
        "airlineIata",
        "number"
      ]),
      departureAirportIata: flight.departureAirport.id,
      localDepartureDay: flight.departureDate.setZone(flight.departureAirport.timeZoneRegionName).toISODate()
    };
  }
  __name(getFlightUniqueIdentifierProperties, "getFlightUniqueIdentifierProperties");
  FlightFacts2.getFlightUniqueIdentifierProperties = getFlightUniqueIdentifierProperties;
  function areFlightsEqual(firstFlight, secondFlight) {
    return _.isEqual(FlightFacts2.getFlightUniqueIdentifierProperties(firstFlight), FlightFacts2.getFlightUniqueIdentifierProperties(secondFlight));
  }
  __name(areFlightsEqual, "areFlightsEqual");
  FlightFacts2.areFlightsEqual = areFlightsEqual;
  function getUniqFlights(flights) {
    return _.uniqWith(flights, areFlightsEqual);
  }
  __name(getUniqFlights, "getUniqFlights");
  FlightFacts2.getUniqFlights = getUniqFlights;
  function isSameFlight(firstFlight, secondFlight) {
    const flightProperties = {
      ..._.pick(firstFlight, [
        "airlineIata",
        "number",
        "departureAirportIata"
      ]),
      departureDateInMillis: firstFlight.departureDate.toMillis()
    };
    const comparedFlightProperties = {
      ..._.pick(secondFlight, [
        "airlineIata",
        "number",
        "departureAirportIata"
      ]),
      departureDateInMillis: secondFlight.departureDate.toMillis()
    };
    return _.isEqual(flightProperties, comparedFlightProperties);
  }
  __name(isSameFlight, "isSameFlight");
  FlightFacts2.isSameFlight = isSameFlight;
})(FlightFacts || (FlightFacts = {}));
var FlightFacts;

// src/facts/segment.facts.ts
(function(SegmentFacts2) {
  function isFlightSegment2(segment) {
    return segment.route.mode === RouteModeEnum.FLIGHT;
  }
  __name(isFlightSegment2, "isFlightSegment");
  SegmentFacts2.isFlightSegment = isFlightSegment2;
  function isBusSegment(segment) {
    return segment.route.mode === RouteModeEnum.BUS;
  }
  __name(isBusSegment, "isBusSegment");
  SegmentFacts2.isBusSegment = isBusSegment;
  function isFerrySegment(segment) {
    return segment.route.mode === RouteModeEnum.FERRY;
  }
  __name(isFerrySegment, "isFerrySegment");
  SegmentFacts2.isFerrySegment = isFerrySegment;
  function isTrainSegment(segment) {
    return segment.route.mode === RouteModeEnum.TRAIN;
  }
  __name(isTrainSegment, "isTrainSegment");
  SegmentFacts2.isTrainSegment = isTrainSegment;
  function isGenericSegment(segment) {
    return !isFlightSegment2(segment);
  }
  __name(isGenericSegment, "isGenericSegment");
  SegmentFacts2.isGenericSegment = isGenericSegment;
  function isSameGenericSegment(segment1, segment2) {
    return segment1.route.mode === segment2.route.mode && segment1.route.externalId === segment2.route.externalId && segment1.route.partnerId === segment2.route.partnerId && segment1.arrivalStop.externalId === segment2.arrivalStop.externalId && segment1.arrivalStop.partnerId === segment2.arrivalStop.partnerId && segment1.departureStop.externalId === segment2.departureStop.externalId && segment1.departureStop.partnerId === segment2.departureStop.partnerId;
  }
  __name(isSameGenericSegment, "isSameGenericSegment");
  SegmentFacts2.isSameGenericSegment = isSameGenericSegment;
  function isSame(segment1, segment2) {
    if (SegmentFacts2.isFlightSegment(segment1) && SegmentFacts2.isFlightSegment(segment2)) {
      return FlightFacts.isSameFlight(SegmentFacts2.flightSegmentToFlight(segment1), SegmentFacts2.flightSegmentToFlight(segment2));
    }
    if (SegmentFacts2.isGenericSegment(segment1) && SegmentFacts2.isGenericSegment(segment2)) {
      return SegmentFacts2.isSameGenericSegment(segment1, segment2);
    }
    return false;
  }
  __name(isSame, "isSame");
  SegmentFacts2.isSame = isSame;
  function getUniqFlightSegments(genericSegments) {
    return _2.uniqWith(genericSegments, (segment1, segment2) => FlightFacts.isSameFlight(SegmentFacts2.flightSegmentToFlight(segment1), SegmentFacts2.flightSegmentToFlight(segment2)));
  }
  __name(getUniqFlightSegments, "getUniqFlightSegments");
  SegmentFacts2.getUniqFlightSegments = getUniqFlightSegments;
  function getUniqGenericSegments(genericSegments) {
    return _2.uniqWith(genericSegments, SegmentFacts2.isSameGenericSegment);
  }
  __name(getUniqGenericSegments, "getUniqGenericSegments");
  SegmentFacts2.getUniqGenericSegments = getUniqGenericSegments;
  function flightToFlightSegment(flight) {
    return {
      arrivalStop: {
        ..."arrivalAirport" in flight ? {
          airport: {
            country: flight.arrivalAirport.country,
            id: flight.arrivalAirport.id,
            timeZoneRegionName: flight.arrivalAirport.timeZoneRegionName
          },
          country: flight.arrivalAirport.country
        } : {},
        date: flight.arrivalDate,
        iata: flight.arrivalAirportIata,
        statuses: flight.statuses
      },
      departureStop: {
        ..."departureAirport" in flight ? {
          airport: {
            country: flight.departureAirport.country,
            id: flight.departureAirport.id,
            timeZoneRegionName: flight.departureAirport.timeZoneRegionName
          },
          country: flight.departureAirport.country
        } : {},
        date: flight.departureDate,
        iata: flight.departureAirportIata
      },
      route: {
        mode: RouteModeEnum.FLIGHT,
        transportIdentifier: {
          airlineIata: flight.airlineIata,
          number: flight.number
        }
      }
    };
  }
  __name(flightToFlightSegment, "flightToFlightSegment");
  SegmentFacts2.flightToFlightSegment = flightToFlightSegment;
  function flightSegmentToFlight(segment) {
    const baseFlight = {
      airlineIata: segment.route.transportIdentifier.airlineIata,
      arrivalAirportIata: segment.arrivalStop.iata,
      arrivalDate: segment.arrivalStop.date,
      departureAirportIata: segment.departureStop.iata,
      departureDate: segment.departureStop.date,
      number: segment.route.transportIdentifier.number,
      statuses: segment.arrivalStop.statuses ?? []
    };
    if ("airport" in segment.arrivalStop && "airport" in segment.departureStop) {
      const flight = {
        ...baseFlight,
        arrivalAirport: segment.arrivalStop.airport,
        departureAirport: segment.departureStop.airport
      };
      return flight;
    }
    return baseFlight;
  }
  __name(flightSegmentToFlight, "flightSegmentToFlight");
  SegmentFacts2.flightSegmentToFlight = flightSegmentToFlight;
  function sort(segments) {
    return [
      ...segments
    ].sort((left, right) => dateTimeAscendingSorter(left.departureStop.date, right.departureStop.date));
  }
  __name(sort, "sort");
  SegmentFacts2.sort = sort;
})(SegmentFacts || (SegmentFacts = {}));
var SegmentFacts;

// src/facts/journey.facts.ts
(function(JourneyFacts2) {
  function getFlightSegments(journey) {
    const segments = JourneyFacts2.getSegments(journey);
    return segments.filter((segment) => SegmentFacts.isFlightSegment(segment));
  }
  __name(getFlightSegments, "getFlightSegments");
  JourneyFacts2.getFlightSegments = getFlightSegments;
  function getSegments(journey) {
    return journey.segments;
  }
  __name(getSegments, "getSegments");
  JourneyFacts2.getSegments = getSegments;
  function getGenericSegments(journey) {
    const segments = JourneyFacts2.getSegments(journey);
    return segments.filter((segment) => SegmentFacts.isGenericSegment(segment));
  }
  __name(getGenericSegments, "getGenericSegments");
  JourneyFacts2.getGenericSegments = getGenericSegments;
  function getSortedFlights(journey) {
    const flights = _3.sortBy(JourneyFacts2.getFlightSegments(journey), ({ departureStop: { date } }) => date.toMillis());
    return flights;
  }
  __name(getSortedFlights, "getSortedFlights");
  JourneyFacts2.getSortedFlights = getSortedFlights;
  function getLastFlight(journey) {
    const flights = JourneyFacts2.getSortedFlights(journey);
    return flights[flights.length - 1];
  }
  __name(getLastFlight, "getLastFlight");
  JourneyFacts2.getLastFlight = getLastFlight;
  function getConnections(journey) {
    const flights = JourneyFacts2.getSortedFlights(journey);
    if (flights.length === 0) {
      throw new Error("No flights in journey.");
    }
    return flights.reduce((result, departureFlight, index) => {
      const arrivalFlight = flights[index + 1];
      if (arrivalFlight) {
        result.push([
          departureFlight,
          arrivalFlight
        ]);
      }
      return result;
    }, []).map(([landingFlight, takingOffFlight]) => ({
      landingFlight,
      takingOffFlight
    }));
  }
  __name(getConnections, "getConnections");
  JourneyFacts2.getConnections = getConnections;
  function getEndDate(journey) {
    const arrivalDates = [
      ...journey.segments.map(({ arrivalStop }) => arrivalStop.date)
    ];
    const endDate = DateTime.max(...arrivalDates);
    if (endDate === void 0) {
      throw new Error(`Impossible to determine the end date of the following journey: ${JSON.stringify(journey)}.`);
    }
    return endDate;
  }
  __name(getEndDate, "getEndDate");
  JourneyFacts2.getEndDate = getEndDate;
  function getStartDate(journey) {
    const departureDates = [
      ...journey.segments.map(({ departureStop }) => departureStop.date)
    ];
    const startDate = DateTime.min(...departureDates);
    if (startDate === void 0) {
      throw new Error(`Impossible to determine the start date of the following journey: ${JSON.stringify(journey)}.`);
    }
    return startDate;
  }
  __name(getStartDate, "getStartDate");
  JourneyFacts2.getStartDate = getStartDate;
  function listAirlineIatas(journey) {
    const flightSegmentsAirlineIata = JourneyFacts2.getSegments(journey).flatMap((segment) => {
      if (SegmentFacts.isFlightSegment(segment)) {
        return [
          segment.route.transportIdentifier.airlineIata
        ];
      }
      return [];
    });
    return _3.uniq(flightSegmentsAirlineIata);
  }
  __name(listAirlineIatas, "listAirlineIatas");
  JourneyFacts2.listAirlineIatas = listAirlineIatas;
  function listAirportIds(journey) {
    return _3.uniq(JourneyFacts2.getFlightSegments(journey).flatMap(({ arrivalStop, departureStop }) => [
      departureStop.iata,
      arrivalStop.iata
    ]));
  }
  __name(listAirportIds, "listAirportIds");
  JourneyFacts2.listAirportIds = listAirportIds;
  function areAllFlightsConnected(journey) {
    const orderedFlights = JourneyFacts2.getSortedFlights(journey);
    return orderedFlights.every((flight, index) => {
      if (orderedFlights.length - 1 === index) {
        return true;
      }
      return flight.arrivalStop.iata === orderedFlights[index + 1].departureStop.iata;
    });
  }
  __name(areAllFlightsConnected, "areAllFlightsConnected");
  JourneyFacts2.areAllFlightsConnected = areAllFlightsConnected;
  function hasSameFlights(journey, comparedJourney) {
    return _3.differenceWith(JourneyFacts2.getFlightSegments(journey), JourneyFacts2.getFlightSegments(comparedJourney), SegmentFacts.isSame).length === 0;
  }
  __name(hasSameFlights, "hasSameFlights");
  JourneyFacts2.hasSameFlights = hasSameFlights;
  function isSame(j1, j2) {
    const j1Segments = JourneyFacts2.getSegments(j1);
    const j2Segments = JourneyFacts2.getSegments(j2);
    return _3.differenceWith(j1Segments, j2Segments, SegmentFacts.isSame).length === 0;
  }
  __name(isSame, "isSame");
  JourneyFacts2.isSame = isSame;
  function areSame(j1, j2) {
    return _3.differenceWith(j1, j2, JourneyFacts2.isSame).length === 0;
  }
  __name(areSame, "areSame");
  JourneyFacts2.areSame = areSame;
  function sort(journeys) {
    return [
      ...journeys
    ].sort((left, right) => dateTimeAscendingSorter2(JourneyFacts2.getStartDate(left), JourneyFacts2.getStartDate(right)));
  }
  __name(sort, "sort");
  JourneyFacts2.sort = sort;
})(JourneyFacts || (JourneyFacts = {}));
var JourneyFacts;

// src/facts/stay.facts.ts
import _4 from "lodash";
import { dateTimeAscendingSorter as dateTimeAscendingSorter3 } from "@repo/lib-utils";
(function(StayFacts2) {
  StayFacts2.FUNNEL_STAY_NAME_PLACEHOLDER = "FUNNEL_STAY_NAME_PLACEHOLDER";
  function name(stay) {
    if (stay.name !== StayFacts2.FUNNEL_STAY_NAME_PLACEHOLDER) {
      return stay.name;
    }
    return `Stay in ${stay.address.country.id}`;
  }
  __name(name, "name");
  StayFacts2.name = name;
  function isSameStay(firstStay, comparedStays) {
    return _4.isEqual({
      endDateInMillis: firstStay.endDate.toMillis(),
      name: firstStay.name,
      startDateInMillis: firstStay.startDate.toMillis()
    }, {
      endDateInMillis: comparedStays.endDate.toMillis(),
      name: comparedStays.name,
      startDateInMillis: comparedStays.startDate.toMillis()
    });
  }
  __name(isSameStay, "isSameStay");
  StayFacts2.isSameStay = isSameStay;
  function areSameStays(stays, comparedStays) {
    return _4.differenceWith(stays, comparedStays, StayFacts2.isSameStay).length === 0;
  }
  __name(areSameStays, "areSameStays");
  StayFacts2.areSameStays = areSameStays;
  function sort(stays) {
    return [
      ...stays
    ].sort((a, b) => dateTimeAscendingSorter3(a.startDate, b.startDate));
  }
  __name(sort, "sort");
  StayFacts2.sort = sort;
})(StayFacts || (StayFacts = {}));
var StayFacts;

// src/facts/trip.facts.ts
(function(TripFacts2) {
  function getCompatibleProductTypes() {
    return Object.entries(ProductFacts.COVERED_EVENT_COMPATIBILITY_MAP).reduce((acc, [productType, coveredEventTypes]) => {
      if (coveredEventTypes.includes(CoveredEventTypeEnum3.TRIP)) {
        acc.push(productType);
      }
      return acc;
    }, new Array());
  }
  __name(getCompatibleProductTypes, "getCompatibleProductTypes");
  TripFacts2.getCompatibleProductTypes = getCompatibleProductTypes;
  function getTripFlightSegments(trip) {
    return trip.journeys.flatMap((journey) => JourneyFacts.getFlightSegments(journey));
  }
  __name(getTripFlightSegments, "getTripFlightSegments");
  TripFacts2.getTripFlightSegments = getTripFlightSegments;
  function getTripStays(trip) {
    return trip.stays;
  }
  __name(getTripStays, "getTripStays");
  TripFacts2.getTripStays = getTripStays;
  function getSegments(trip) {
    return trip.journeys.flatMap(JourneyFacts.getSegments);
  }
  __name(getSegments, "getSegments");
  TripFacts2.getSegments = getSegments;
  function getGenericSegments(trip) {
    return trip.journeys.flatMap((j) => JourneyFacts.getGenericSegments(j));
  }
  __name(getGenericSegments, "getGenericSegments");
  TripFacts2.getGenericSegments = getGenericSegments;
  function getDates(trip) {
    const segmentDates = TripFacts2.getSegments(trip).flatMap(({ departureStop, arrivalStop }) => [
      departureStop.date,
      arrivalStop.date
    ]);
    const staysDates = TripFacts2.getTripStays(trip).flatMap(({ startDate: startDate2, endDate: endDate2 }) => [
      startDate2,
      endDate2
    ]);
    const startDate = DateTime2.min(...staysDates, ...segmentDates);
    const endDate = DateTime2.max(...staysDates, ...segmentDates);
    if (startDate === void 0 || endDate === void 0) {
      throw new Error(`Impossible to determine the dates of the following trip: ${JSON.stringify(trip)}.`);
    }
    return {
      endDate,
      startDate
    };
  }
  __name(getDates, "getDates");
  TripFacts2.getDates = getDates;
  function listAirlineIatas(trip) {
    return _5.uniq(trip.journeys.flatMap(JourneyFacts.listAirlineIatas));
  }
  __name(listAirlineIatas, "listAirlineIatas");
  TripFacts2.listAirlineIatas = listAirlineIatas;
  function listAirportIds(trip) {
    return _5.uniq(trip.journeys.flatMap(JourneyFacts.listAirportIds));
  }
  __name(listAirportIds, "listAirportIds");
  TripFacts2.listAirportIds = listAirportIds;
  function listCountries(trip) {
    const segmentCountries = TripFacts2.getSegments(trip).flatMap(({ departureStop, arrivalStop }) => [
      departureStop.country,
      arrivalStop.country
    ]);
    const stayCountries = TripFacts2.getTripStays(trip).flatMap(({ address }) => address.country);
    return _5.uniqBy([
      ...stayCountries,
      ...segmentCountries
    ], "id");
  }
  __name(listCountries, "listCountries");
  TripFacts2.listCountries = listCountries;
  function getFirstFlight(trip) {
    const flights = TripFacts2.getTripFlightSegments(trip);
    flights.sort(({ departureStop: { date: departureDate } }, { departureStop: { date: nextDepartureDate } }) => dateTimeAscendingSorter4(departureDate, nextDepartureDate));
    return flights[0] ?? null;
  }
  __name(getFirstFlight, "getFirstFlight");
  TripFacts2.getFirstFlight = getFirstFlight;
  function getFirstFlightOrSegment(trip) {
    const segments = TripFacts2.getSegments(trip);
    const sortedFlightsAndSegments = [
      ...segments
    ].sort((leftFlightOrSegment, rightFlightOrSegment) => {
      const leftDepartureDate = leftFlightOrSegment.departureStop.date;
      const rightDepartureDate = rightFlightOrSegment.departureStop.date;
      return dateTimeAscendingSorter4(leftDepartureDate, rightDepartureDate);
    });
    return sortedFlightsAndSegments[0] ?? null;
  }
  __name(getFirstFlightOrSegment, "getFirstFlightOrSegment");
  TripFacts2.getFirstFlightOrSegment = getFirstFlightOrSegment;
  function getLastFlightOrSegment(trip) {
    const segments = TripFacts2.getSegments(trip);
    const sortedFlightsAndSegments = [
      ...segments
    ].sort((leftFlightOrSegment, rightFlightOrSegment) => {
      const leftArrivalDate = leftFlightOrSegment.arrivalStop.date;
      const rightArrivalDate = rightFlightOrSegment.arrivalStop.date;
      return dateTimeAscendingSorter4(leftArrivalDate, rightArrivalDate);
    });
    return sortedFlightsAndSegments.at(-1) ?? null;
  }
  __name(getLastFlightOrSegment, "getLastFlightOrSegment");
  TripFacts2.getLastFlightOrSegment = getLastFlightOrSegment;
  function getCountryOfDeparture(trip) {
    const firstFlightOrSegment = TripFacts2.getFirstFlightOrSegment(trip);
    if (firstFlightOrSegment === null) {
      return null;
    }
    return firstFlightOrSegment.departureStop.country;
  }
  __name(getCountryOfDeparture, "getCountryOfDeparture");
  TripFacts2.getCountryOfDeparture = getCountryOfDeparture;
  function isSameTripFlights(trip, comparedTrip) {
    const flights = TripFacts2.getTripFlightSegments(trip);
    const comparedFlights = TripFacts2.getTripFlightSegments(comparedTrip);
    return _5.differenceWith(flights, comparedFlights, SegmentFacts.isSame).length === 0;
  }
  __name(isSameTripFlights, "isSameTripFlights");
  TripFacts2.isSameTripFlights = isSameTripFlights;
  function isSameTrip(trip, comparedTrip) {
    return _5.isEqualWith(trip.stays, comparedTrip.stays, StayFacts.areSameStays) && _5.isEqualWith(trip.journeys, comparedTrip.journeys, JourneyFacts.areSame);
  }
  __name(isSameTrip, "isSameTrip");
  TripFacts2.isSameTrip = isSameTrip;
  function getLatestStartDateBetweenLastJourneyAndLastStay(trip) {
    const lastStayStartDate = trip.stays.at(-1)?.startDate;
    const lastJourney = trip.journeys.at(-1)?.segments.at(-1)?.departureStop.date;
    const date = [
      lastStayStartDate,
      lastJourney
    ].filter(isNotUndefined).sort(dateTimeAscendingSorter4).at(-1);
    if (date === void 0) {
      throw new Error("Could not find a date for the last element of the trip");
    }
    return date;
  }
  __name(getLatestStartDateBetweenLastJourneyAndLastStay, "getLatestStartDateBetweenLastJourneyAndLastStay");
  TripFacts2.getLatestStartDateBetweenLastJourneyAndLastStay = getLatestStartDateBetweenLastJourneyAndLastStay;
})(TripFacts || (TripFacts = {}));
var TripFacts;

// src/facts/contract.facts.ts
var allContractEventTypeAttributesToNull = {
  flightToJourney: null,
  flightToJourneyId: null,
  journey: null,
  journeyId: null,
  trip: null,
  tripId: null
};
function mapFlightContract(contract) {
  if (contract.flightToJourney === null || contract.flightToJourneyId === null) {
    throw new Error(`Unable to find flightToJourney for contractId "${contract.id}".`);
  }
  return {
    ...contract,
    ...allContractEventTypeAttributesToNull,
    flightToJourney: contract.flightToJourney,
    flightToJourneyId: contract.flightToJourneyId
  };
}
__name(mapFlightContract, "mapFlightContract");
function mapTripContract(contract) {
  if (contract.trip === null || contract.tripId === null) {
    throw new Error(`Unable to find trip for contractId "${contract.id}".`);
  }
  return {
    ...contract,
    ...allContractEventTypeAttributesToNull,
    trip: contract.trip,
    tripId: contract.trip.id
  };
}
__name(mapTripContract, "mapTripContract");
(function(ContractFacts2) {
  function isContractCoveredEventType(contract, name) {
    return contract.productBundle.product.coveredEventType === name;
  }
  __name(isContractCoveredEventType, "isContractCoveredEventType");
  ContractFacts2.isContractCoveredEventType = isContractCoveredEventType;
  function extractFlights(contract) {
    if ("flight" in contract) {
      return [
        contract.flight
      ];
    }
    if ("trip" in contract) {
      return TripFacts.getTripFlightSegments(contract.trip);
    }
    throw new Error("Unable to extract flights from contract.");
  }
  __name(extractFlights, "extractFlights");
  ContractFacts2.extractFlights = extractFlights;
  function getStartDate(contract) {
    if (contract.productBundle.product.type === ProductTypeEnum3.WITHDRAWAL) {
      return contract.subscribedAt;
    }
    return ContractFacts2.getCoveredEventStartDate(contract);
  }
  __name(getStartDate, "getStartDate");
  ContractFacts2.getStartDate = getStartDate;
  function getCoveredEventStartDate(contract) {
    if (isContractCoveredEventType(contract, CoveredEventTypeEnum4.FLIGHT)) {
      return contract.flight.departureStop.date;
    }
    if (isContractCoveredEventType(contract, CoveredEventTypeEnum4.TRIP)) {
      return TripFacts.getDates(contract.trip).startDate;
    }
    throw new Error(`Impossible to determine the start date of the following contract: ${JSON.stringify(contract)}.`);
  }
  __name(getCoveredEventStartDate, "getCoveredEventStartDate");
  ContractFacts2.getCoveredEventStartDate = getCoveredEventStartDate;
  function getCoveredEventEndDate(contract) {
    if (isContractCoveredEventType(contract, CoveredEventTypeEnum4.FLIGHT)) {
      return contract.flight.arrivalStop.date;
    }
    if (isContractCoveredEventType(contract, CoveredEventTypeEnum4.TRIP)) {
      return TripFacts.getDates(contract.trip).endDate;
    }
    throw new Error(`Impossible to determine the end date of the following contract: ${JSON.stringify(contract)}.`);
  }
  __name(getCoveredEventEndDate, "getCoveredEventEndDate");
  ContractFacts2.getCoveredEventEndDate = getCoveredEventEndDate;
  function getDeletedAt(contract) {
    return contract.renouncedAt ?? contract.replacedAt ?? null;
  }
  __name(getDeletedAt, "getDeletedAt");
  ContractFacts2.getDeletedAt = getDeletedAt;
  function getEligibilityCutoff(tripStartDate, minimumPeriodBeforeStart) {
    const tripStartDateInUtc = tripStartDate.toUTC();
    if (minimumPeriodBeforeStart === null || minimumPeriodBeforeStart === void 0) {
      return tripStartDateInUtc;
    }
    return tripStartDateInUtc.minus(Duration.fromISO(minimumPeriodBeforeStart));
  }
  __name(getEligibilityCutoff, "getEligibilityCutoff");
  ContractFacts2.getEligibilityCutoff = getEligibilityCutoff;
  function mapContractFromProductType(contract) {
    const { coveredEventType } = contract.productBundle.product;
    switch (coveredEventType) {
      case CoveredEventTypeEnum4.FLIGHT:
        return mapFlightContract(contract);
      case CoveredEventTypeEnum4.TRIP:
        return mapTripContract(contract);
      case CoveredEventTypeEnum4.STAY:
      default:
        throw new Error(`Contract type "${coveredEventType}" is not handled for contractId "${contract.id}".`);
    }
  }
  __name(mapContractFromProductType, "mapContractFromProductType");
  ContractFacts2.mapContractFromProductType = mapContractFromProductType;
  function throwOnUnsupportedContracts(contract) {
    const { type } = contract.product;
    if (type === ProductTypeEnum3.WITHDRAWAL && contract.flight !== void 0) {
      throw new Error(`This action on contract "${contract.id}" of type WITHDRAWAL for covered event FLIGHT is not supported.`);
    }
  }
  __name(throwOnUnsupportedContracts, "throwOnUnsupportedContracts");
  ContractFacts2.throwOnUnsupportedContracts = throwOnUnsupportedContracts;
  function getExpirationDate(contract, validityPeriod) {
    const { type } = contract.productBundle.product;
    const startDate = ContractFacts2.getCoveredEventStartDate(contract);
    if (type === ProductTypeEnum3.COMPREHENSIVE) {
      return startDate.plus(Duration.fromObject({
        days: 30
      }));
    }
    if (!validityPeriod) {
      throw new Error(`Cannot determine expiration date because contract is of type "${type}" and no validityPeriod was provided.`);
    }
    const validityPeriodDuration = Duration.fromISO(validityPeriod);
    const flights = ContractFacts2.extractFlights(contract);
    switch (type) {
      case ProductTypeEnum3.FLIGHT_DISRUPTION:
        return flights[0].arrivalStop.date.plus(validityPeriodDuration);
      case ProductTypeEnum3.WITHDRAWAL:
        return startDate.plus(validityPeriodDuration);
      case ProductTypeEnum3.CHANGE_FOR_ANY_REASON:
        if ("trip" in contract) {
          return TripFacts.getLatestStartDateBetweenLastJourneyAndLastStay(contract.trip).plus(validityPeriodDuration);
        }
        throw new Error(`Change for any reason contract with ID: ${contract.id} does not have a trip.`);
      case ProductTypeEnum3.BAGGAGE_DISRUPTION:
        return startDate.plus({
          months: 2
        });
      case ProductTypeEnum3.CANCELLATION_WITHOUT_PROOF:
        return startDate.plus(validityPeriodDuration);
      default:
        throw new Error(`Product type ${type} is not supported.`);
    }
  }
  __name(getExpirationDate, "getExpirationDate");
  ContractFacts2.getExpirationDate = getExpirationDate;
})(ContractFacts || (ContractFacts = {}));
var ContractFacts;

// src/facts/external-claim.facts.ts
import { ClaimStatusEnum as ClaimStatusEnum2 } from "@repo/lib-koala-types";
var EXTERNAL_CLAIM_STATUS_RANKS = {
  [ClaimStatusEnum2.MANUAL_VERIFICATION_NEEDED]: 1,
  [ClaimStatusEnum2.ACCEPTED]: 2,
  [ClaimStatusEnum2.REJECTED]: 3,
  [ClaimStatusEnum2.REFUNDED]: 3
};
(function(ExternalClaimFacts2) {
  function isStatusMovingForward(currentStatus, nextStatus) {
    return getStatusRank(nextStatus) > getStatusRank(currentStatus);
  }
  __name(isStatusMovingForward, "isStatusMovingForward");
  ExternalClaimFacts2.isStatusMovingForward = isStatusMovingForward;
  function getStatusRank(status) {
    const rank = EXTERNAL_CLAIM_STATUS_RANKS[status];
    if (rank === void 0) {
      throw new Error(`Claim status "${status}" is not supported for external claims.`);
    }
    return rank;
  }
  __name(getStatusRank, "getStatusRank");
})(ExternalClaimFacts || (ExternalClaimFacts = {}));
var ExternalClaimFacts;

// src/facts/flight-status.facts.ts
import { FlightStatusEnum as FlightStatusEnum2, FlightStatusProviderEnum } from "@repo/lib-koala-types";
import { dateTimeDescendingSorter } from "@repo/lib-utils";
(function(FlightStatusFacts2) {
  FlightStatusFacts2.MINIMUM_RELIABILITY = 95;
  function getActual(flightStatuses) {
    if (flightStatuses.length === 0) {
      return null;
    }
    flightStatuses.sort((a, b) => dateTimeDescendingSorter(a.updatedAt, b.updatedAt));
    const koalaFlightStatuses = flightStatuses.filter(({ provider }) => provider === FlightStatusProviderEnum.KOALA);
    if (koalaFlightStatuses.length > 0) {
      return koalaFlightStatuses[0];
    }
    const partnerFlightStatuses = flightStatuses.filter(({ provider }) => provider === FlightStatusProviderEnum.PARTNER);
    if (partnerFlightStatuses.length > 0) {
      return partnerFlightStatuses[0];
    }
    return flightStatuses[0];
  }
  __name(getActual, "getActual");
  FlightStatusFacts2.getActual = getActual;
  function isReliable({ reliability }) {
    return reliability >= FlightStatusFacts2.MINIMUM_RELIABILITY;
  }
  __name(isReliable, "isReliable");
  FlightStatusFacts2.isReliable = isReliable;
  FlightStatusFacts2.FINAL_STATUSES = [
    FlightStatusEnum2.CANCELED,
    FlightStatusEnum2.DIVERTED,
    FlightStatusEnum2.LANDED
  ];
  function isFinal({ status }) {
    return FlightStatusFacts2.FINAL_STATUSES.includes(status);
  }
  __name(isFinal, "isFinal");
  FlightStatusFacts2.isFinal = isFinal;
  function isCanceled({ status }) {
    return status === FlightStatusEnum2.CANCELED;
  }
  __name(isCanceled, "isCanceled");
  FlightStatusFacts2.isCanceled = isCanceled;
  function isDiverted({ status }) {
    return status === FlightStatusEnum2.DIVERTED;
  }
  __name(isDiverted, "isDiverted");
  FlightStatusFacts2.isDiverted = isDiverted;
  function isLanded({ status }) {
    return status === FlightStatusEnum2.LANDED;
  }
  __name(isLanded, "isLanded");
  FlightStatusFacts2.isLanded = isLanded;
  function containsFinalFlightStatus(flightStatuses) {
    return flightStatuses.some((flightStatus) => isFinal(flightStatus));
  }
  __name(containsFinalFlightStatus, "containsFinalFlightStatus");
  FlightStatusFacts2.containsFinalFlightStatus = containsFinalFlightStatus;
})(FlightStatusFacts || (FlightStatusFacts = {}));
var FlightStatusFacts;

// src/facts/json-logic-sentences.facts.ts
import { Info } from "luxon";
(function(JsonLogicSentencesFacts2) {
  const isRecord = /* @__PURE__ */ __name((value) => typeof value === "object" && value !== null, "isRecord");
  const isVarRef = /* @__PURE__ */ __name((value) => isRecord(value) && typeof value.var === "string", "isVarRef");
  const withVarInArgs = /* @__PURE__ */ __name((args, variableName) => {
    if (!Array.isArray(args)) {
      return [];
    }
    const [first, ...rest] = args;
    if (!isRecord(first)) {
      return args;
    }
    return [
      {
        ...first,
        var: variableName
      },
      ...rest
    ];
  }, "withVarInArgs");
  function mapVariableNames(variableName) {
    const variableMap = {
      nbOfStays: "Stays",
      nbOfJourneys: "Journeys",
      "price.amount": "Price",
      "price.currency": "Currency",
      hoursBeforeDeparture: "Hours before departure",
      departureDate: "Departure date",
      departureDayOfWeek: "Departure day",
      nbOfTravelers: "Number of travelers",
      countries: "Countries",
      modes: "Transportation modes",
      nbOfFlightSegments: "flight segments",
      nbOfBusSegments: "bus segments",
      nbOfFerrySegments: "ferry segments",
      nbOfTrainSegments: "train segments",
      tripOrigin: "Origin",
      tripDestination: "Destination",
      originCountry: "Country of origin",
      destinationCountry: "Country of destination",
      tripDurationInDays: "Trip duration in days",
      hasConnection: "has connection",
      nbOfConnections: "connections",
      maxLayoverDurationInHours: "max layover in hours",
      hasOvernightLayover: "has overnight layover",
      nbOfStopovers: "stopovers",
      isMultiDestination: "multidestination",
      isRoundTrip: "roundtrip",
      isInternational: "international",
      nbOfDistinctAirlines: "distinct airlines",
      airlines: "Airlines",
      departureContinentPair: "departure continent pair",
      providerUncoveredAmountRatio: "Non-refundable share"
    };
    return variableMap[variableName] || variableName;
  }
  __name(mapVariableNames, "mapVariableNames");
  JsonLogicSentencesFacts2.mapVariableNames = mapVariableNames;
  function mapOperatorName(operator) {
    const operatorMap = {
      some: "in",
      "===": "="
    };
    return operatorMap[operator] || operator;
  }
  __name(mapOperatorName, "mapOperatorName");
  JsonLogicSentencesFacts2.mapOperatorName = mapOperatorName;
  function getCurrencySymbol(currency) {
    const symbolMap = {
      EUR: "\u20AC",
      GBP: "\xA3",
      CZK: "K\u010D",
      PLN: "z\u0142",
      HUF: "Ft",
      SEK: "kr"
    };
    return symbolMap[currency.toUpperCase()] || currency;
  }
  __name(getCurrencySymbol, "getCurrencySymbol");
  JsonLogicSentencesFacts2.getCurrencySymbol = getCurrencySymbol;
  function formatHoursBeforeDeparture(operator, hours) {
    const mappedOperator = mapOperatorName(operator);
    if (hours % 24 === 0) {
      const days = hours / 24;
      return `Departure ${mappedOperator} ${days}d`;
    }
    return `Departure ${mappedOperator} ${hours}h`;
  }
  __name(formatHoursBeforeDeparture, "formatHoursBeforeDeparture");
  JsonLogicSentencesFacts2.formatHoursBeforeDeparture = formatHoursBeforeDeparture;
  function formatPriceSentence(operator, value) {
    return `${mapOperatorName(operator)}${value}`;
  }
  __name(formatPriceSentence, "formatPriceSentence");
  JsonLogicSentencesFacts2.formatPriceSentence = formatPriceSentence;
  function formatTravelerSentence(operator, value) {
    const label = value === 1 ? "Traveler" : "Travelers";
    return `${mapOperatorName(operator)}${value} ${label}`;
  }
  __name(formatTravelerSentence, "formatTravelerSentence");
  JsonLogicSentencesFacts2.formatTravelerSentence = formatTravelerSentence;
  function formatSegmentSentence(variableName, operator, value) {
    const label = value === 1 ? variableName.replace(" segments", " segment") : variableName;
    return `${mapOperatorName(operator)}${value} ${label}`;
  }
  __name(formatSegmentSentence, "formatSegmentSentence");
  JsonLogicSentencesFacts2.formatSegmentSentence = formatSegmentSentence;
  const weekdayLabels = Info.weekdays("short", {
    locale: "en-GB"
  });
  const normalizeWeekdayValue = /* @__PURE__ */ __name((value) => {
    let numericValue = null;
    if (typeof value === "number") {
      numericValue = value;
    } else if (typeof value === "string") {
      numericValue = Number(value);
    }
    if (numericValue === null || !Number.isInteger(numericValue) || numericValue < 1 || numericValue > 7) {
      return null;
    }
    return numericValue;
  }, "normalizeWeekdayValue");
  const toWeekdayLabel = /* @__PURE__ */ __name((value) => {
    const weekdayValue = normalizeWeekdayValue(value);
    if (weekdayValue === null) {
      return null;
    }
    return weekdayLabels[weekdayValue - 1] ?? null;
  }, "toWeekdayLabel");
  const buildWeekdayRange = /* @__PURE__ */ __name((start, end) => {
    const labels = [];
    for (let day = start; day <= end; day += 1) {
      const label = weekdayLabels[day - 1];
      if (label) {
        labels.push(label);
      }
    }
    return labels;
  }, "buildWeekdayRange");
  const formatInSentence = /* @__PURE__ */ __name((variableName, operatorName, value, isNegated) => {
    const valueStr = Array.isArray(value) ? value.join(",") : value;
    return `${variableName}${isNegated ? " not " : " "}${operatorName} ${valueStr}`;
  }, "formatInSentence");
  const formatGenericComparison = /* @__PURE__ */ __name((variableName, operator, value, isNegated) => {
    const operatorName = mapOperatorName(operator);
    const valueStr = isVarRef(value) ? mapVariableNames(value.var) : `${value}`;
    return `${variableName}${isNegated ? " not " : " "}${operatorName} ${valueStr}`;
  }, "formatGenericComparison");
  const formatDepartureDayInList = /* @__PURE__ */ __name((values) => {
    const labels = values.map(toWeekdayLabel).filter((label) => Boolean(label));
    return labels.length > 0 ? `Departure day on ${labels.join("/")}` : null;
  }, "formatDepartureDayInList");
  function formatDepartureDayOfWeek(operator, value, variableName, isNegated) {
    const weekdayValue = normalizeWeekdayValue(value);
    if (weekdayValue === null) {
      return formatGenericComparison(variableName, operator, value, isNegated);
    }
    const operatorHandlers = {
      "===": /* @__PURE__ */ __name((day) => buildWeekdayRange(day, day), "==="),
      "==": /* @__PURE__ */ __name((day) => buildWeekdayRange(day, day), "=="),
      "!=": /* @__PURE__ */ __name((day) => weekdayLabels.filter((_9, index) => index + 1 !== day), "!="),
      "!==": /* @__PURE__ */ __name((day) => weekdayLabels.filter((_9, index) => index + 1 !== day), "!=="),
      "<": /* @__PURE__ */ __name((day) => buildWeekdayRange(1, day - 1), "<"),
      "<=": /* @__PURE__ */ __name((day) => buildWeekdayRange(1, day), "<="),
      ">": /* @__PURE__ */ __name((day) => buildWeekdayRange(day + 1, 7), ">"),
      ">=": /* @__PURE__ */ __name((day) => buildWeekdayRange(day, 7), ">=")
    };
    const handler = operatorHandlers[operator];
    if (!handler) {
      return formatGenericComparison(variableName, operator, value, isNegated);
    }
    const labels = handler(weekdayValue);
    if (labels.length === 0) {
      return formatGenericComparison(variableName, operator, value, isNegated);
    }
    return `Departure day on ${labels.join("/")}`;
  }
  __name(formatDepartureDayOfWeek, "formatDepartureDayOfWeek");
  JsonLogicSentencesFacts2.formatDepartureDayOfWeek = formatDepartureDayOfWeek;
  const RATIO_VAR = "providerUncoveredAmountRatio";
  const CATEGORIES_VAR = "providerRefundabilityCategories";
  function formatRefundabilityCategory(category) {
    return category.charAt(0) + category.slice(1).toLowerCase().replaceAll("_", "-");
  }
  __name(formatRefundabilityCategory, "formatRefundabilityCategory");
  JsonLogicSentencesFacts2.formatRefundabilityCategory = formatRefundabilityCategory;
  function formatRatioAsPercentage(value) {
    return `${Math.round(value * 1e4) / 100}%`;
  }
  __name(formatRatioAsPercentage, "formatRatioAsPercentage");
  JsonLogicSentencesFacts2.formatRatioAsPercentage = formatRatioAsPercentage;
  const isCategoryMembership = /* @__PURE__ */ __name((clause) => {
    if (!isRecord(clause) || !Array.isArray(clause.in)) {
      return false;
    }
    const [category, varPart] = clause.in;
    return typeof category === "string" && isVarRef(varPart) && varPart.var === CATEGORIES_VAR;
  }, "isCategoryMembership");
  const isRatioNullGuard = /* @__PURE__ */ __name((clause) => {
    if (!isRecord(clause)) {
      return false;
    }
    const operator = Object.keys(clause)[0];
    if (operator !== "!==" && operator !== "!=") {
      return false;
    }
    const [varPart, value] = Array.isArray(clause[operator]) ? clause[operator] : [];
    return isVarRef(varPart) && varPart.var === RATIO_VAR && value === null;
  }, "isRatioNullGuard");
  const asRatioBound = /* @__PURE__ */ __name((clause) => {
    if (!isRecord(clause)) {
      return null;
    }
    const operator = Object.keys(clause)[0];
    if (![
      ">",
      ">=",
      "<",
      "<="
    ].includes(operator)) {
      return null;
    }
    const [varPart, value] = Array.isArray(clause[operator]) ? clause[operator] : [];
    if (!isVarRef(varPart) || varPart.var !== RATIO_VAR || typeof value !== "number") {
      return null;
    }
    return {
      operator,
      value
    };
  }, "asRatioBound");
  const collapseRefundabilityClauses = /* @__PURE__ */ __name((args) => {
    const membership = args.find(isCategoryMembership);
    const bounds = args.map(asRatioBound).filter((bound) => bound !== null);
    const shouldCollapse = membership !== void 0 && bounds.length > 0;
    const lowerBound = bounds.find(({ operator }) => operator.startsWith(">"))?.value ?? 0;
    const upperBound = bounds.find(({ operator }) => operator.startsWith("<"))?.value ?? 1;
    const rangeSentence = `${formatRatioAsPercentage(lowerBound)}\u2013${formatRatioAsPercentage(upperBound)} non-refundable`;
    return args.flatMap((clause) => {
      if (isRatioNullGuard(clause)) {
        return [];
      }
      if (shouldCollapse && clause === membership) {
        return [
          clause,
          {
            sentence: rangeSentence
          }
        ];
      }
      if (shouldCollapse && asRatioBound(clause) !== null) {
        return [];
      }
      return [
        clause
      ];
    });
  }, "collapseRefundabilityClauses");
  function handleAnd(args, context) {
    const conditions = collapseRefundabilityClauses(args);
    const results = [];
    conditions.forEach((condition, index) => {
      const conjunction = index < conditions.length - 1 ? "AND" : "";
      if (isRecord(condition) && typeof condition.sentence === "string") {
        results.push(conjunction ? `${condition.sentence} ${conjunction}` : condition.sentence);
        return;
      }
      results.push(...context.processFn(condition, conjunction, context.isNegated));
    });
    return results;
  }
  __name(handleAnd, "handleAnd");
  JsonLogicSentencesFacts2.handleAnd = handleAnd;
  function handleOr(args, context) {
    const results = [];
    args.forEach((condition, index) => {
      const branchResults = context.processFn(condition, "", context.isNegated);
      if (branchResults.length > 1) {
        branchResults[0] = `(${branchResults[0]}`;
        branchResults[branchResults.length - 1] = `${branchResults[branchResults.length - 1]})`;
      }
      results.push(...branchResults);
      if (index < args.length - 1) {
        results.push("OR");
      }
    });
    if (context.conjunction && results.length > 0) {
      results[results.length - 1] += ` ${context.conjunction}`;
    }
    return results;
  }
  __name(handleOr, "handleOr");
  JsonLogicSentencesFacts2.handleOr = handleOr;
  function handleNot(args, context) {
    return context.processFn(args[0], context.conjunction, true);
  }
  __name(handleNot, "handleNot");
  JsonLogicSentencesFacts2.handleNot = handleNot;
  function handleArrayOperator(args, context) {
    const [varPart, ...conditions] = args;
    if (!isVarRef(varPart)) {
      return [
        `Invalid array operator: ${JSON.stringify(args)}`
      ];
    }
    const variableName = mapVariableNames(varPart.var.replace(/^var\./, ""));
    const results = [];
    conditions.forEach((condition) => {
      if (!isRecord(condition)) {
        return;
      }
      const conditionOperator = Object.keys(condition)[0];
      if (conditionOperator === "!") {
        const negated = condition["!"];
        if (!isRecord(negated)) {
          return;
        }
        const operator = Object.keys(negated)[0];
        if (!operator) {
          return;
        }
        const negatedArgs = withVarInArgs(negated[operator], variableName);
        results.push(...context.processFn({
          [operator]: negatedArgs
        }, "", true));
      } else {
        const operator = conditionOperator;
        if (!operator) {
          return;
        }
        const updatedArgs = withVarInArgs(condition[operator], variableName);
        results.push(...context.processFn({
          [operator]: updatedArgs
        }, "", false));
      }
    });
    return results;
  }
  __name(handleArrayOperator, "handleArrayOperator");
  JsonLogicSentencesFacts2.handleArrayOperator = handleArrayOperator;
  const extractAmountComparisons = /* @__PURE__ */ __name((condition) => {
    if (typeof condition !== "object" || condition === null) {
      return [];
    }
    if ("and" in condition) {
      return condition.and;
    }
    return [
      condition
    ];
  }, "extractAmountComparisons");
  function handleIf(args, _context) {
    let currency = null;
    const amountConditions = [];
    let firstCurrencyProcessed = false;
    args.forEach((condition) => {
      if (typeof condition === "object" && condition !== null && "===" in condition) {
        const eqCondition = condition;
        const varPart = eqCondition["==="][0];
        if (varPart?.var === "price.currency") {
          currency = eqCondition["==="][1];
          return;
        }
      }
      if (!currency || firstCurrencyProcessed) {
        return;
      }
      const comparisons = extractAmountComparisons(condition);
      comparisons.forEach((amountCond, index) => {
        if (typeof amountCond !== "object" || amountCond === null) {
          return;
        }
        const op = Object.keys(amountCond)[0];
        const amountCondObj = amountCond;
        const varPart = amountCondObj[op]?.[0];
        if (op && varPart?.var === "price.amount") {
          const amount = amountCondObj[op][1];
          const symbol = getCurrencySymbol(currency);
          const suffix = index < comparisons.length - 1 ? " AND" : "";
          amountConditions.push(`${op}${amount} ${symbol}${suffix}`);
        }
      });
      firstCurrencyProcessed = true;
    });
    return amountConditions;
  }
  __name(handleIf, "handleIf");
  JsonLogicSentencesFacts2.handleIf = handleIf;
  const formatLiteralMembershipSentence = /* @__PURE__ */ __name((first, second, isNegated) => {
    const transportModes = [
      "FLIGHT",
      "BUS",
      "FERRY",
      "TRAIN"
    ];
    if (typeof first !== "string" || !isVarRef(second)) {
      return null;
    }
    if (transportModes.includes(first) && second.var === "modes") {
      return first.charAt(0) + first.slice(1).toLowerCase();
    }
    if (second.var === CATEGORIES_VAR) {
      const categoryLabel = formatRefundabilityCategory(first);
      return isNegated ? `Not ${categoryLabel.toLowerCase()}` : categoryLabel;
    }
    return null;
  }, "formatLiteralMembershipSentence");
  function handleIn(args, context) {
    const [first, second] = args;
    let sentence = formatLiteralMembershipSentence(first, second, context.isNegated) ?? "";
    if (!sentence && isVarRef(first)) {
      const rawVarName = first.var.replace(/^var\./, "");
      const variableName = mapVariableNames(rawVarName);
      const operatorName = mapOperatorName("in");
      if (rawVarName === "departureDayOfWeek" && Array.isArray(second)) {
        sentence = formatDepartureDayInList(second) ?? formatInSentence(variableName, operatorName, second, context.isNegated);
      } else {
        sentence = formatInSentence(variableName, operatorName, second, context.isNegated);
      }
    }
    if (context.conjunction && sentence) {
      sentence += ` ${context.conjunction}`;
    }
    return sentence ? [
      sentence
    ] : [];
  }
  __name(handleIn, "handleIn");
  JsonLogicSentencesFacts2.handleIn = handleIn;
  const formatRefundabilityComparison = /* @__PURE__ */ __name((rawVarName, operator, value, isNegated) => {
    if (rawVarName === RATIO_VAR && typeof value === "number") {
      return `${mapVariableNames(rawVarName)} ${mapOperatorName(operator)} ${formatRatioAsPercentage(value)}`;
    }
    if (rawVarName === "isRoundTrip" && typeof value === "boolean" && [
      "===",
      "==",
      "!==",
      "!="
    ].includes(operator)) {
      const isNegativeOperator = operator === "!==" || operator === "!=";
      const isRoundTrip2 = value !== isNegativeOperator !== isNegated;
      return isRoundTrip2 ? "Round trip" : "Not round trip";
    }
    return null;
  }, "formatRefundabilityComparison");
  const formatComparisonSentence = /* @__PURE__ */ __name((rawVarName, operator, value, isNegated) => {
    const variableName = mapVariableNames(rawVarName);
    const refundabilitySentence = formatRefundabilityComparison(rawVarName, operator, value, isNegated);
    if (refundabilitySentence !== null) {
      return refundabilitySentence;
    }
    if (rawVarName === "price.amount") {
      return formatPriceSentence(operator, value);
    }
    if (rawVarName === "nbOfTravelers") {
      return formatTravelerSentence(operator, value);
    }
    if (rawVarName === "hoursBeforeDeparture" && typeof value === "number") {
      return formatHoursBeforeDeparture(operator, value);
    }
    if (rawVarName === "departureDayOfWeek") {
      return formatDepartureDayOfWeek(operator, value, variableName, isNegated);
    }
    if (variableName.includes("segments") || variableName === "Transportation modes") {
      return formatSegmentSentence(variableName, operator, value);
    }
    return formatGenericComparison(variableName, operator, value, isNegated);
  }, "formatComparisonSentence");
  function createBinaryOperatorHandler(operator) {
    return (args, context) => {
      const [varPart, value] = args;
      if (!isVarRef(varPart)) {
        return [
          `Invalid comparison: ${JSON.stringify(args)}`
        ];
      }
      const rawVarName = varPart.var.replace(/^var\./, "");
      if (rawVarName === RATIO_VAR && value === null) {
        return [];
      }
      let sentence = formatComparisonSentence(rawVarName, operator, value, context.isNegated);
      if (context.conjunction) {
        sentence += ` ${context.conjunction}`;
      }
      return [
        sentence
      ];
    };
  }
  __name(createBinaryOperatorHandler, "createBinaryOperatorHandler");
  JsonLogicSentencesFacts2.createBinaryOperatorHandler = createBinaryOperatorHandler;
  const handlerMap = {
    and: handleAnd,
    or: handleOr,
    if: handleIf,
    in: handleIn,
    "!": handleNot,
    some: handleArrayOperator,
    all: handleArrayOperator,
    none: handleArrayOperator,
    "===": createBinaryOperatorHandler("==="),
    "==": createBinaryOperatorHandler("=="),
    "!==": createBinaryOperatorHandler("!=="),
    "!=": createBinaryOperatorHandler("!="),
    ">": createBinaryOperatorHandler(">"),
    ">=": createBinaryOperatorHandler(">="),
    "<": createBinaryOperatorHandler("<"),
    "<=": createBinaryOperatorHandler("<=")
  };
  function processLogic(logic, conjunction = "", isNegated = false) {
    if (logic === false) {
      return [
        "Disabled"
      ];
    }
    if (!isRecord(logic)) {
      return [];
    }
    const operator = Object.keys(logic)[0];
    if (!operator) {
      return [];
    }
    const rawArgs = logic[operator];
    const args = Array.isArray(rawArgs) ? rawArgs : operator === "!" ? [
      rawArgs
    ] : [];
    let handler = handlerMap[operator];
    if (!handler) {
      handler = createBinaryOperatorHandler(operator);
    }
    const context = {
      processFn: processLogic,
      conjunction,
      isNegated
    };
    return handler(args, context);
  }
  __name(processLogic, "processLogic");
  JsonLogicSentencesFacts2.processLogic = processLogic;
  function jsonLogicToSentences(jsonLogicString) {
    try {
      const jsonLogic = JSON.parse(jsonLogicString);
      return processLogic(jsonLogic);
    } catch (_error) {
      return [
        "Could not interpret JSON properly."
      ];
    }
  }
  __name(jsonLogicToSentences, "jsonLogicToSentences");
  JsonLogicSentencesFacts2.jsonLogicToSentences = jsonLogicToSentences;
  const TRANSPORT_MODES = [
    "FLIGHT",
    "BUS",
    "FERRY",
    "TRAIN"
  ];
  const SEMI_REFUNDABLE_CATEGORY = "SEMI_REFUNDABLE";
  const asModeMembership = /* @__PURE__ */ __name((clause) => {
    if (!isRecord(clause) || !Array.isArray(clause.in)) {
      return null;
    }
    const [mode, varPart] = clause.in;
    return typeof mode === "string" && TRANSPORT_MODES.includes(mode) && isVarRef(varPart) && varPart.var === "modes" ? mode : null;
  }, "asModeMembership");
  const asSemiRefundability = /* @__PURE__ */ __name((clause, isNegated) => {
    if (!isCategoryMembership(clause) || clause.in[0] !== SEMI_REFUNDABLE_CATEGORY) {
      return null;
    }
    return isNegated ? "NOT_SEMI_REFUNDABLE" : "SEMI_REFUNDABLE";
  }, "asSemiRefundability");
  const childClauses = /* @__PURE__ */ __name((node) => {
    const operator = Object.keys(node)[0];
    if (!operator) {
      return {
        clauses: [],
        negatesChildren: false
      };
    }
    const rawArgs = node[operator];
    return {
      clauses: Array.isArray(rawArgs) ? rawArgs : [
        rawArgs
      ],
      negatesChildren: operator === "!"
    };
  }, "childClauses");
  const parseJsonLogic = /* @__PURE__ */ __name((jsonLogicString) => {
    try {
      return JSON.parse(jsonLogicString);
    } catch (error) {
      if (error instanceof SyntaxError) {
        return null;
      }
      throw error;
    }
  }, "parseJsonLogic");
  function extractPreConditionFilters(jsonLogicString) {
    const modes = /* @__PURE__ */ new Set();
    let semiRefundability = null;
    const collectFilters = /* @__PURE__ */ __name((node, isNegated) => {
      if (!isRecord(node)) {
        return;
      }
      const mode = asModeMembership(node);
      if (mode !== null) {
        modes.add(mode);
        return;
      }
      const semiRefundabilityMatch = asSemiRefundability(node, isNegated);
      if (semiRefundabilityMatch !== null) {
        semiRefundability = semiRefundabilityMatch;
        return;
      }
      const { clauses, negatesChildren } = childClauses(node);
      clauses.forEach((clause) => collectFilters(clause, negatesChildren ? !isNegated : isNegated));
    }, "collectFilters");
    collectFilters(parseJsonLogic(jsonLogicString), false);
    return {
      modes: [
        ...modes
      ],
      semiRefundability
    };
  }
  __name(extractPreConditionFilters, "extractPreConditionFilters");
  JsonLogicSentencesFacts2.extractPreConditionFilters = extractPreConditionFilters;
})(JsonLogicSentencesFacts || (JsonLogicSentencesFacts = {}));
var JsonLogicSentencesFacts;

// src/facts/pricing-factors/compute-pricing-factors.ts
import _7 from "lodash";
import { RouteModeEnum as RouteModeEnum3 } from "@repo/lib-koala-types";

// src/facts/pricing-factors/resolve-segment-geography.ts
import { getAirport } from "@repo/lib-airports";
import { countries as countriesData } from "@repo/lib-countries";
import { RouteModeEnum as RouteModeEnum2 } from "@repo/lib-koala-types";
function isFlightSegment(segment) {
  return segment.route.mode === RouteModeEnum2.FLIGHT;
}
__name(isFlightSegment, "isFlightSegment");
function resolveCountryCode(segment, stop) {
  const stopData = segment[stop];
  if (stopData.countryCode) {
    return stopData.countryCode;
  }
  if (isFlightSegment(segment)) {
    return getAirport(stopData.identifier.toUpperCase())?.countryId;
  }
  return void 0;
}
__name(resolveCountryCode, "resolveCountryCode");
function resolveTimezone(segment, stop) {
  if (isFlightSegment(segment)) {
    return getAirport(segment[stop].identifier.toUpperCase())?.timeZoneRegionName;
  }
  return void 0;
}
__name(resolveTimezone, "resolveTimezone");
function getRegionForCountryCode(countryCode) {
  return countriesData.find((c) => c.id === countryCode)?.region ?? null;
}
__name(getRegionForCountryCode, "getRegionForCountryCode");

// src/facts/pricing-factors/compute-connection-facts.ts
var MAX_CONNECTION_DURATION_IN_HOURS = 24;
function getGapInHours(arriving, departing) {
  return departing.departureStop.date.diff(arriving.arrivalStop.date).as("hours");
}
__name(getGapInHours, "getGapInHours");
function isOvernightGap(arriving, departing) {
  const arrival = arriving.arrivalStop.date;
  const departure = departing.departureStop.date;
  const arrivalTz = resolveTimezone(arriving, "arrivalStop");
  const departureTz = resolveTimezone(departing, "departureStop");
  const arrivalLocal = arrivalTz ? arrival.setZone(arrivalTz) : arrival;
  const departureLocal = departureTz ? departure.setZone(departureTz) : departure;
  return arrivalLocal.day !== departureLocal.day;
}
__name(isOvernightGap, "isOvernightGap");
function findLongestGapIndex(sorted) {
  if (sorted.length < 2) {
    return null;
  }
  let longestIndex = 0;
  let longestDuration = getGapInHours(sorted[0], sorted[1]);
  for (let i = 1; i < sorted.length - 1; i++) {
    const duration = getGapInHours(sorted[i], sorted[i + 1]);
    if (duration > longestDuration) {
      longestDuration = duration;
      longestIndex = i;
    }
  }
  return longestIndex;
}
__name(findLongestGapIndex, "findLongestGapIndex");
function getAnalyzableGaps(sorted, destinationStayGapIndex) {
  const gaps = [];
  for (let i = 0; i < sorted.length - 1; i++) {
    if (i !== destinationStayGapIndex) {
      gaps.push({
        index: i,
        gapInHours: getGapInHours(sorted[i], sorted[i + 1])
      });
    }
  }
  return gaps;
}
__name(getAnalyzableGaps, "getAnalyzableGaps");
function classifyConsecutivePairs(sorted, destinationStayGapIndex) {
  const gaps = getAnalyzableGaps(sorted, destinationStayGapIndex);
  let nbOfConnections = 0;
  let nbOfStopovers = 0;
  let maxLayoverDurationInHours = null;
  let hasOvernightLayover = false;
  for (const { index, gapInHours } of gaps) {
    if (gapInHours > MAX_CONNECTION_DURATION_IN_HOURS) {
      nbOfStopovers++;
      continue;
    }
    nbOfConnections++;
    if (maxLayoverDurationInHours === null || gapInHours > maxLayoverDurationInHours) {
      maxLayoverDurationInHours = gapInHours;
    }
    if (isOvernightGap(sorted[index], sorted[index + 1])) {
      hasOvernightLayover = true;
    }
  }
  return {
    nbOfConnections,
    nbOfStopovers,
    maxLayoverDurationInHours,
    hasOvernightLayover
  };
}
__name(classifyConsecutivePairs, "classifyConsecutivePairs");
function computeConnectionFacts(sortedSegments, isRoundTrip2) {
  const destinationStayGapIndex = isRoundTrip2 ? findLongestGapIndex(sortedSegments) : null;
  const { nbOfConnections, nbOfStopovers, maxLayoverDurationInHours, hasOvernightLayover } = classifyConsecutivePairs(sortedSegments, destinationStayGapIndex);
  return {
    hasConnection: nbOfConnections > 0,
    nbOfConnections,
    maxLayoverDurationInHours,
    hasOvernightLayover,
    nbOfStopovers,
    isMultiDestination: nbOfStopovers > 0
  };
}
__name(computeConnectionFacts, "computeConnectionFacts");

// src/facts/pricing-factors/compute-ticket-refund-factors.ts
import Decimal2 from "decimal.js";
import _6 from "lodash";
var EMPTY_TICKET_REFUND_FACTORS = {
  providerRefundabilityCategories: [],
  estimatedProviderRefundAmount: null,
  estimatedProviderUncoveredAmount: null,
  providerUncoveredAmountRatio: null
};
function sumSingleCurrencyAmounts(prices) {
  if (prices.some((price) => price === void 0)) {
    return null;
  }
  const definedPrices = prices.filter((price) => price !== void 0);
  if (_6.uniq(definedPrices.map((price) => price.currency)).length > 1) {
    return null;
  }
  return definedPrices.reduce((sum, price) => sum.plus(price.amount), new Decimal2(0));
}
__name(sumSingleCurrencyAmounts, "sumSingleCurrencyAmounts");
function computeTicketRefundFactors(ticketRefundContexts) {
  if (ticketRefundContexts === void 0 || ticketRefundContexts.length === 0) {
    return EMPTY_TICKET_REFUND_FACTORS;
  }
  const ticketPriceTotal = sumSingleCurrencyAmounts(ticketRefundContexts.map((context) => context.ticketPrice));
  const refundTotal = sumSingleCurrencyAmounts(ticketRefundContexts.map((context) => context.estimatedProviderRefund));
  const uncoveredTotal = sumSingleCurrencyAmounts(ticketRefundContexts.map((context) => context.estimatedProviderUncoveredAmount));
  return {
    providerRefundabilityCategories: _6.uniq(ticketRefundContexts.map((context) => context.providerRefundabilityCategory)),
    estimatedProviderRefundAmount: refundTotal === null ? null : refundTotal.toNumber(),
    estimatedProviderUncoveredAmount: uncoveredTotal === null ? null : uncoveredTotal.toNumber(),
    providerUncoveredAmountRatio: uncoveredTotal === null || ticketPriceTotal === null || ticketPriceTotal.isZero() ? null : uncoveredTotal.dividedBy(ticketPriceTotal).toNumber()
  };
}
__name(computeTicketRefundFactors, "computeTicketRefundFactors");

// src/facts/pricing-factors/compute-pricing-factors.ts
function getTripDates(trip) {
  const segmentDates = trip.journeys.flatMap((j) => j.segments.flatMap((s) => [
    s.departureStop.date,
    s.arrivalStop.date
  ]));
  const stayDates = trip.stays.flatMap((s) => [
    s.startDate,
    s.endDate
  ]);
  const allDates = [
    ...segmentDates,
    ...stayDates
  ];
  if (allDates.length === 0) {
    throw new Error(`Cannot get dates for trip '${JSON.stringify(trip)}': no segments or stays.`);
  }
  return {
    startDate: allDates.reduce((min, d) => d < min ? d : min),
    endDate: allDates.reduce((max, d) => d > max ? d : max)
  };
}
__name(getTripDates, "getTripDates");
function getSegmentCounts(segments) {
  return {
    nbOfFlightSegments: segments.filter((s) => s.route.mode === RouteModeEnum3.FLIGHT).length,
    nbOfBusSegments: segments.filter((s) => s.route.mode === RouteModeEnum3.BUS).length,
    nbOfFerrySegments: segments.filter((s) => s.route.mode === RouteModeEnum3.FERRY).length,
    nbOfTrainSegments: segments.filter((s) => s.route.mode === RouteModeEnum3.TRAIN).length
  };
}
__name(getSegmentCounts, "getSegmentCounts");
function getModesFromCounts(counts) {
  const modes = [];
  if (counts.nbOfFlightSegments > 0) {
    modes.push(RouteModeEnum3.FLIGHT);
  }
  if (counts.nbOfBusSegments > 0) {
    modes.push(RouteModeEnum3.BUS);
  }
  if (counts.nbOfFerrySegments > 0) {
    modes.push(RouteModeEnum3.FERRY);
  }
  if (counts.nbOfTrainSegments > 0) {
    modes.push(RouteModeEnum3.TRAIN);
  }
  return modes;
}
__name(getModesFromCounts, "getModesFromCounts");
function sortSegmentsByDeparture(segments) {
  return [
    ...segments
  ].sort((a, b) => a.departureStop.date.toMillis() - b.departureStop.date.toMillis());
}
__name(sortSegmentsByDeparture, "sortSegmentsByDeparture");
function isRoundTrip(sortedSegments) {
  if (sortedSegments.length < 2) {
    return false;
  }
  const first = sortedSegments[0];
  const last = sortedSegments[sortedSegments.length - 1];
  return first.departureStop.identifier === last.arrivalStop.identifier;
}
__name(isRoundTrip, "isRoundTrip");
function getDestinationSegment(sortedSegments, roundTrip) {
  if (sortedSegments.length === 0) {
    return void 0;
  }
  if (roundTrip) {
    const longestGapIndex = findLongestGapIndex(sortedSegments);
    if (longestGapIndex !== null) {
      return sortedSegments[longestGapIndex];
    }
  }
  return sortedSegments[sortedSegments.length - 1];
}
__name(getDestinationSegment, "getDestinationSegment");
function listDatedCountryCodes(trip, allSegments) {
  const segmentEvents = allSegments.flatMap((s) => [
    {
      date: s.departureStop.date,
      countryCode: resolveCountryCode(s, "departureStop")
    },
    {
      date: s.arrivalStop.date,
      countryCode: resolveCountryCode(s, "arrivalStop")
    }
  ]);
  const stayEvents = trip.stays.map((s) => ({
    date: s.startDate,
    countryCode: s.countryCode
  }));
  return [
    ...segmentEvents,
    ...stayEvents
  ];
}
__name(listDatedCountryCodes, "listDatedCountryCodes");
function collectCountryCodes(trip, allSegments) {
  const events = listDatedCountryCodes(trip, allSegments).sort((a, b) => a.date.toMillis() - b.date.toMillis());
  return _7.uniq(events.map((e) => e.countryCode).filter((c) => c !== void 0));
}
__name(collectCountryCodes, "collectCountryCodes");
function collectAirlineIatas(segments) {
  const airlineIatas = segments.filter((s) => s.route.mode === RouteModeEnum3.FLIGHT).map((s) => s.route.airlineIata?.toUpperCase()).filter((iata) => iata !== void 0);
  return _7.uniq(airlineIatas);
}
__name(collectAirlineIatas, "collectAirlineIatas");
function computeDepartureContinentPair(originCountry, destinationCountry) {
  if (!originCountry || !destinationCountry) {
    return null;
  }
  const originRegion = getRegionForCountryCode(originCountry);
  const destinationRegion = getRegionForCountryCode(destinationCountry);
  if (!originRegion || !destinationRegion) {
    return null;
  }
  return `${originRegion}-${destinationRegion}`;
}
__name(computeDepartureContinentPair, "computeDepartureContinentPair");
function computePricingFactors(trip, quoteDate) {
  const allSegments = trip.journeys.flatMap((j) => j.segments);
  const sortedSegments = sortSegmentsByDeparture(allSegments);
  const { startDate, endDate } = getTripDates(trip);
  const segmentCounts = getSegmentCounts(allSegments);
  const roundTrip = isRoundTrip(sortedSegments);
  const firstSegment = sortedSegments[0];
  const destinationSegment = getDestinationSegment(sortedSegments, roundTrip);
  const countries = collectCountryCodes(trip, allSegments);
  const connectionFacts = computeConnectionFacts(sortedSegments, roundTrip);
  const originCountry = firstSegment ? resolveCountryCode(firstSegment, "departureStop") : void 0;
  const destinationCountry = destinationSegment ? resolveCountryCode(destinationSegment, "arrivalStop") : void 0;
  const numberOfCheckedBags = trip.travelers.reduce((acc, t) => acc + (t.numberOfCheckedBags ?? 0), 0);
  const airlines = collectAirlineIatas(allSegments);
  return {
    departureDate: startDate.toISO(),
    arrivalDate: endDate.toISO(),
    hoursBeforeDeparture: startDate.diff(quoteDate).as("hours"),
    nbOfJourneys: trip.journeys.length,
    nbOfTravelers: trip.travelers.length,
    nbOfStays: trip.stays.length,
    modes: getModesFromCounts(segmentCounts),
    ...segmentCounts,
    countries,
    tripOrigin: firstSegment?.departureStop.identifier,
    tripDestination: destinationSegment?.arrivalStop.identifier,
    originCountry,
    destinationCountry,
    departureDayOfWeek: startDate.weekday,
    tripDurationInDays: Math.round(endDate.diff(startDate).as("days")),
    isRoundTrip: roundTrip,
    isInternational: countries.length > 1,
    nbOfDistinctAirlines: airlines.length,
    airlines,
    departureContinentPair: computeDepartureContinentPair(originCountry, destinationCountry),
    numberOfCheckedBags,
    ...connectionFacts,
    ...computeTicketRefundFactors(trip.ticketRefundContexts)
  };
}
__name(computePricingFactors, "computePricingFactors");

// src/facts/pricing-factors/compute-battleface-facts.ts
function listCountryVisits(trip, allSegments) {
  const segmentVisits = allSegments.flatMap((s) => [
    {
      date: s.departureStop.date,
      countryCode: resolveCountryCode(s, "departureStop"),
      isStay: false
    },
    {
      date: s.arrivalStop.date,
      countryCode: resolveCountryCode(s, "arrivalStop"),
      isStay: false
    }
  ]);
  const stayVisits = trip.stays.map((s) => ({
    date: s.startDate,
    countryCode: s.countryCode,
    isStay: true
  }));
  return [
    ...segmentVisits,
    ...stayVisits
  ].sort((a, b) => a.date.toMillis() - b.date.toMillis()).filter((visit) => visit.countryCode !== void 0);
}
__name(listCountryVisits, "listCountryVisits");
function resolveDestinationCountryCodes(trip, roundTrip) {
  const allSegments = trip.journeys.flatMap((j) => j.segments);
  const visits = listCountryVisits(trip, allSegments);
  const firstVisit = visits[0];
  const lastVisit = visits[visits.length - 1];
  const destinationVisits = [
    ...visits
  ];
  if (!firstVisit.isStay) {
    destinationVisits.shift();
  }
  if (roundTrip && !lastVisit.isStay) {
    destinationVisits.pop();
  }
  if (destinationVisits.length === 0) {
    return visits.map((visit) => visit.countryCode);
  }
  return destinationVisits.map((visit) => visit.countryCode);
}
__name(resolveDestinationCountryCodes, "resolveDestinationCountryCodes");
function computeBattlefaceFacts(trip, quoteDate) {
  const pricingFactors = computePricingFactors(trip, quoteDate);
  return {
    ...pricingFactors,
    destinationCountryCodes: resolveDestinationCountryCodes(trip, pricingFactors.isRoundTrip)
  };
}
__name(computeBattlefaceFacts, "computeBattlefaceFacts");

// src/facts/product-attachment.facts.ts
(function(ProductAttachmentFacts2) {
  ProductAttachmentFacts2.LEGACY_BUCKET_ORIGIN = "https://koala-emails-data.s3.eu-west-3.amazonaws.com";
  ProductAttachmentFacts2.LEGACY_BUCKET_PATH_PREFIX = "/pdfs/";
  ProductAttachmentFacts2.PER_STAGE_BUCKET_HOST = /^koala-emails-data-\d{12}-(development|release|staging|production)\.s3\.eu-west-1\.amazonaws\.com$/;
  function isTrustedUrl(rawUrl) {
    let url;
    try {
      url = new URL(rawUrl);
    } catch {
      return false;
    }
    if (url.protocol !== "https:") {
      return false;
    }
    if (url.username !== "" || url.password !== "") {
      return false;
    }
    if (url.origin === ProductAttachmentFacts2.LEGACY_BUCKET_ORIGIN) {
      return url.pathname.startsWith(ProductAttachmentFacts2.LEGACY_BUCKET_PATH_PREFIX);
    }
    return ProductAttachmentFacts2.PER_STAGE_BUCKET_HOST.test(url.host);
  }
  __name(isTrustedUrl, "isTrustedUrl");
  ProductAttachmentFacts2.isTrustedUrl = isTrustedUrl;
})(ProductAttachmentFacts || (ProductAttachmentFacts = {}));
var ProductAttachmentFacts;

// src/facts/product-pricing-overview/calculate-premium-as-percentage-of-booking-price.ts
import _8 from "lodash";
import { PriceSettingTypeEnum as PriceSettingTypeEnum2, ProductPricingSettingCoefficientPropertyEnum } from "@repo/lib-koala-types";
function calculatePremiumAsPercentageOfBookingPrice(settings) {
  if (settings.pricingSettings.type === PriceSettingTypeEnum2.COEFFICIENT && settings.pricingSettings.coefficientProperty === ProductPricingSettingCoefficientPropertyEnum.NON_REFUNDABLE_TRIP_PRICE) {
    return null;
  }
  if (settings.pricingSettings.type === PriceSettingTypeEnum2.COEFFICIENT && settings.pricingSettings.coefficientProperty === ProductPricingSettingCoefficientPropertyEnum.TRIP_PRICE) {
    return settings.pricingSettings.value;
  }
  if (settings.pricingSettings.type === PriceSettingTypeEnum2.COEFFICIENT && "compensationSettings" in settings) {
    if (settings.compensationSettings[0].type === PriceSettingTypeEnum2.FIXED) {
      return null;
    }
    const [highestCompensationSetting] = _8.orderBy(settings.compensationSettings, [
      "value"
    ], [
      "desc"
    ]);
    return settings.pricingSettings.value * highestCompensationSetting.value;
  }
  return null;
}
__name(calculatePremiumAsPercentageOfBookingPrice, "calculatePremiumAsPercentageOfBookingPrice");

// src/facts/product-pricing-overview/calculate-retail-price-as-fixed-amount.ts
import { PriceSettingTypeEnum as PriceSettingTypeEnum3, ProductPricingSettingCoefficientPropertyEnum as ProductPricingSettingCoefficientPropertyEnum2 } from "@repo/lib-koala-types";
function calculateRetailPriceAsFixedAmount(settings) {
  if (settings.pricingSettings.type === PriceSettingTypeEnum3.FIXED || settings.pricingSettings.type === PriceSettingTypeEnum3.COEFFICIENT && settings.pricingSettings.coefficientProperty === ProductPricingSettingCoefficientPropertyEnum2.TRIP_DURATION) {
    if (settings.pricingSettings.value === 0) {
      return null;
    }
    return settings.pricingSettings.value;
  }
  return null;
}
__name(calculateRetailPriceAsFixedAmount, "calculateRetailPriceAsFixedAmount");

// src/facts/product-pricing-overview/product-pricing-overview.facts.ts
import { FRENCH_IPT_RATE, LEGACY_PRICER_MIGRATION_DATE, PriceSettingTypeEnum as PriceSettingTypeEnum4, ProductCommissionSettingCoefficientPropertyEnum, ProductPricingProviderEnum, ProductPricingSettingCoefficientPropertyEnum as ProductPricingSettingCoefficientPropertyEnum3, ProductProviderEnum, ProductTypeEnum as ProductTypeEnum4 } from "@repo/lib-koala-types";

// src/partners.ts
var BIZAWAY_PARTNER_NAME = "BizAway";
var DIRECT_FERRIES_PARTNER_NAME = "Direct Ferries";
var PARTNERS = {
  ASL_AIRLINES: {
    name: "ASL Airlines",
    id: "183d5e15-5c34-4116-9f22-eb76764fff2f",
    address: "Cargo 9 - B\xE2timent Le S\xE9quoia - 15 rue du Haut de Laval 93290 Tremblay - France"
  },
  AFERRY: {
    name: "AFerry",
    id: "e2bdf3ea-150a-4970-b372-d8c9a88c00ac",
    address: "2morrow Court Appleford Road, Sutton Courtenay, Oxfordshire, OX14 4FH, United Kingdom"
  },
  ALPIN_RESORTS: {
    name: "AlpinResorts",
    id: "ff2d3150-2ff9-476f-8b3e-b5919ea5013c",
    address: ""
  },
  AS_MONACO: {
    name: "AS Monaco",
    id: "49b1f598-6ac8-4922-a0b3-9e04c9365449",
    address: "7 Avenue des Castelans \u2013 Stade Louis II \u2013 98 000 Monaco"
  },
  ASSE: {
    name: "ASSE",
    id: "a6a0990f-1339-47e1-98f7-28c937eaf184",
    address: "589, rue de Verdun 42580 L'\xC9trat"
  },
  AVA: {
    name: "AVA",
    id: "27bd0e24-bb71-41b6-9217-2c048925d3c7",
    address: "25, rue de Maubeuge \u2013 75009 PARIS"
  },
  AYRUU: {
    name: "Ayruu",
    id: "15496547-1e84-59f8-aea3-032e6523d394",
    address: "38 rue de Berri, 75008 Paris (France)"
  },
  BEACH_CHECK: {
    name: "Beach Check",
    id: "344bd72a-780d-44d3-9947-9e1f4db31812",
    address: ""
  },
  BIZAWAY: {
    name: "BizAway",
    id: "a3bc338a-0c32-48af-ae3f-daef81e4633b",
    address: "Spilimbergo (PN) 33097, Piazzetta Walterpertoldo n. 4 \u2013 Italy"
  },
  BOATSY: {
    name: "Boatsy",
    id: "69a00ffb-a3d6-402b-a2a7-0a5d59185700",
    address: "84 Iverna Court, W8 6TU; London, UK"
  },
  BON_VOYAGE: {
    name: "Bon Voyage",
    id: "e3544838-5c19-4086-82c9-4f9e397edf8b",
    address: "33 RUE PHILIPPE DE GIRARD 75010 PARIS, France"
  },
  CAPTAIN_WILD: {
    name: "Captain Wild",
    id: "6760308f-c856-4263-bebe-0e3522dbc96c",
    address: "Route de la Bouvarde, Park Nord, 74370 Epagny Metz-Tessy"
  },
  CARTRAWLER: {
    name: "CarTrawler",
    id: "28202e79-294a-41e3-8382-8d8750196082",
    address: "Classon House, Dundrum Business Park, Dundrum, Dublin 14, Ireland"
  },
  CHALAIR: {
    name: "Chalair",
    id: "4639feaa-2177-46ad-961f-c43e5302aa1b",
    address: "Caen-Carpiquet Airport, 14650 CARPIQUET, France"
  },
  CLOOPER: {
    name: "Clooper",
    id: "3e42e993-135f-5a0a-aa5a-ebff6163c4e5",
    address: "20-22 Wenlock Rd, London N1 7GU, United Kingdom"
  },
  COMBIGO: {
    name: "Combigo",
    id: "31e45468-cb54-4a4c-baba-8920ad1521f9",
    address: "33 rue Fernard Pelloutier 92110 Clichy - France"
  },
  CRAZY_VOYAGES: {
    name: "Crazy Voyages",
    id: "d391ef14-5f82-402a-9d20-c76509e9f278",
    address: "8 rue du Faubourg Poissonni\xE8re 75010"
  },
  DHARMA: {
    name: "Dharma",
    id: "b0641a2d-d152-4e24-9782-12caaef0348c",
    address: ""
  },
  DIRECT_FERRIES: {
    name: "Direct Ferries",
    id: "c08e6923-0fb7-43b8-bc5f-fac912615f0b",
    address: "2-3 Three Rivers Business Centre, Felixstowe Road, Ipswich, Suffolk IP10 0BF"
  },
  DUBAIHOP_PURCHASE_FUNNEL: {
    name: "DubaiHop Purchase Funnel",
    id: "c660c2cd-0a56-4388-8e16-6dbfa0582f56",
    address: ""
  },
  EMIRATES_PURCHASE_FUNNEL: {
    name: "Emirates Purchase Funnel",
    id: "c660c2cd-0a56-4388-8e16-6dbfa0582f56",
    address: ""
  },
  EPCR: {
    name: "EPCR",
    id: "563dfd9f-c0e1-477d-a99a-32f433eb9418",
    address: "Boulevard de Grancy 39, 1006 Lausanne, Suisse"
  },
  EXCLUSIVE_GOLF_TRAVEL: {
    name: "Exclusive Golf Travel",
    id: "0fcf490f-aec1-414e-b9f1-e695da4289e4",
    address: "Vacation House, 8 Marlborough Business Centre, 96 George Lane, London, E18 1AD, United Kingdom"
  },
  FAIRJUNGLE: {
    name: "FairJungle",
    id: "1d9267e2-80cc-4dc4-968e-97456ef9dd6c",
    address: ""
  },
  FC_NANTES: {
    name: "FC Nantes",
    id: "f66f1bb8-b1e6-4fc3-969b-6e7ba00c8c03",
    address: "Route de la Joneli\xE8re 44240 LA CHAPELLE-SUR-ERDRE"
  },
  FIRST_CHOICE: {
    name: "First Choice",
    id: "969c4cca-098e-4e07-967c-a9dc7fe375b7",
    address: "Wigmore House, Wigmore Lane, Luton, LU2 9TN, United Kingdom"
  },
  FLIPO_PURCHASE_FUNNEL: {
    name: "Flipo Purchase Funnel",
    id: "d5812a59-d3dd-4274-9daf-a05a232879b4",
    address: ""
  },
  FLUEGE: {
    name: "Fluege",
    id: "d503b750-c8e1-4ac3-879e-80351c96bab5",
    address: "Dittrichring 18\u201320, 04109 Leipzig, Germany"
  },
  FLYLA: {
    name: "Flyla",
    id: "cb7edabc-54d4-4653-aa49-ce802cf2c028",
    address: "K\xFCchelb\xE4ckerstra\xDFe 3, 80331 M\xFCnchen Germany"
  },
  FRU: {
    name: "Fru",
    id: "179c47cb-d955-4947-9fa0-5f91a453ad0a",
    address: "29 Listopada Street 85, 31-406 Krak\xF3w"
  },
  GLOBAL_TOURS: {
    name: "Global Tours",
    id: "b1f54413-aa11-5596-9d51-70300946d345",
    address: "5 rue Thorel 75002 PARIS"
  },
  GOODTIME_MONTY: {
    name: "Goodtime Monty",
    id: "38384454-58d3-4071-b81b-0ef738ca891a",
    address: "Grzeg\xF3rzecka 67d /83, 31-559 Krakow Poland"
  },
  GO_KOALA: {
    name: "Go-Koala",
    id: "e732c58d-08de-4a62-9f79-7f278f8d9706",
    address: "10 Grand Street Brooklyn, NY 11249"
  },
  HIDDEN_ICELAND: {
    name: "Hidden Iceland",
    id: "7d010bc2-1c26-50f8-96d8-ad51d500467b",
    address: "Reykjav\xEDk, Capital Region 101, Iceland"
  },
  HOBLIQ: {
    name: "Hobliq",
    id: "80238009-62a6-4db2-adc9-04e334c61d91",
    address: "73 Rue de Vaugirard, 75006 Paris"
  },
  HOTELSTON: {
    name: "Hotelston",
    id: "92277662-5186-46b4-8154-9336434fac03",
    address: ""
  },
  HOTEL_SPECIALS: {
    name: "Hotel Specials",
    id: "2155b417-c571-4e02-bb2e-fbe734fc233e",
    address: "Hendrik Figeeweg 1, 2031 BJ Haarlem, Netherlands"
  },
  ICELANDIC_ROAMERS: {
    name: "Icelandic Roamers",
    id: "3bd6d4fa-a6a8-4bf4-9bd7-5635f1b4c480",
    address: ""
  },
  IRONMAN: {
    name: "Ironman",
    id: "9072d601-6bd6-4e88-aee9-788168000d8d",
    address: "3407 West Martin Luther King Jr. Blvd, Suite #100, Tampa, Florida, USA"
  },
  IWOFLY: {
    name: "Iwofly",
    id: "e1a8ec43-eed6-4685-b00d-97a3038757ec",
    address: "Paseo de las Delicias 30, 7a planta de la localidad de Madrid, 28045, Spain"
  },
  JAKNALETENKY_PURCHASE_FUNNEL: {
    name: "Jaknaletenky Purchase Funnel",
    id: "bfeadedb-3ded-4f58-93cc-3587e5f0cd8e",
    address: ""
  },
  JAPAN_EXPERIENCE: {
    name: "Japan Experience",
    id: "61a9ee10-3abd-4b7e-9d96-ab4461da04ff",
    address: "30 rue Saint-Anne 75001 Paris"
  },
  KOOKIE: {
    name: "Kookie",
    id: "c00b5656-3d32-4f8d-aca1-c6f6db64dd4b",
    address: "59 Boulevard de la R\xE9publique 13100 Aix en Provence - France"
  },
  KOOKIE_PURCHASE_FUNNEL: {
    name: "Kookie Purchase Funnel",
    id: "e6a1b4a2-9010-4616-80f0-316f71c69e6f",
    address: "59 Boulevard de la R\xE9publique 13100 Aix en Provence - France"
  },
  LANES_AND_PLANES: {
    name: "Lanes&planes",
    id: "716cdb60-8384-4cd7-b9fd-38f0e92cca5a",
    address: "Kap West, Friedenheimer Br\xFCcke 16, 80639 Munich, Germany"
  },
  LAYA: {
    name: "Laya",
    id: "a4a8c4ac-33f5-43e8-b106-da7401c2d7b2",
    address: ""
  },
  LE_COLLECTIONIST: {
    name: "Le Collectionist",
    id: "8f2ac1dd-0b7b-44df-8309-ce705f46b68a",
    address: "65 rue de la Victoire - 75009 Paris, France"
  },
  LIKNOSS: {
    name: "Liknoss",
    id: "85cfcb7a-db08-4738-9f9e-9b2051d51633",
    address: "2-4 Ilioupoleos Ave. 17237 Imittos, Athens, Greece"
  },
  LOOKING_FOR_SOCCER: {
    name: "Looking For Soccer",
    id: "51199534-c338-4353-a6cf-d76f632129a3",
    address: "146 RUE DE CHARENTON \u2013 75012 \u2013 PARIS"
  },
  MARATHON_SINGAPORE: {
    name: "Marathon Singapore",
    id: "4708a36e-2e0d-4688-8c3f-e1e630fe5fdb",
    address: "221 Henderson Road 15 Singapore"
  },
  MARCO_VASCO: {
    name: "Marco Vasco",
    id: "a2879afa-a9c2-4917-94c1-3fbfdd278a8e",
    address: "101 rue de l'Abb\xE9 Groult 75015 Paris"
  },
  MONDE_AUTHENTIQUE: {
    name: "Monde Authentique",
    id: "b61b0cff-db6a-58fa-a846-f8ee18b6018d",
    address: "5 rue Thorel 75002 PARIS"
  },
  MONTAGNE_EXPERT: {
    name: "Montagne Expert",
    id: "6a22b43d-1644-401f-b652-f54389056afc",
    address: "9 rue Mstislav Rostropovitch, 75017 Paris"
  },
  MUBI_XPERIENCE: {
    name: "MUBI Xperience",
    id: "e581cb51-fd86-49b7-a63f-86e8d8bdcaef",
    address: "14 Rue du Mont-Blanc, 1201 Geneva, Switzerland"
  },
  MY_GIBRALTAR: {
    name: "MyGibraltar",
    id: "2c0b6c27-fe0d-4e43-bf0c-2d12af097c0f",
    address: "Lily House, 11 the shrubberies, George lane, London, E18 1BD, United Kingdom"
  },
  MYLITTLETRIP: {
    name: "MyLittleTrip",
    id: "e011800e-6736-41d1-ba52-1dbfc9cf361a",
    address: "144 rue Paul Bellamy, 44000 Nantes"
  },
  NOMADOR: {
    name: "Nomador",
    id: "f94eca22-1603-43a8-9d23-2421879553de",
    address: "41 rue de Richelieu, 75001 Paris, FRANCE"
  },
  NORTOURS: {
    name: "nortours",
    id: "86df873a-b485-53cc-ba2b-cee71afa9c0d",
    address: "5 rue Thorel 75002 PARIS"
  },
  OJIMAH: {
    name: "Ojimah",
    id: "1fb69ffc-668b-45c5-9b75-c3255a2ebe9b",
    address: "Av. do Atl\xE2ntico 16, Edif\xEDcio Panoramic Parque das Na\xE7\xF5es 1990-019. Lisbon, Portugal"
  },
  OLIVERS_TRAVELS: {
    name: "Oliver's Travels",
    id: "c5e9871d-196e-4548-980c-fb0e3663e14a",
    address: "Unit 1.01, Chester House, Kennington Park, 1-3 Brixton Road, London, SW9 6DE"
  },
  OMIO: {
    name: "Omio",
    id: "b6940de9-4875-4b48-b2c2-df26bd630415",
    address: "Warschauer Platz 12, 10245 Berlin, Germany"
  },
  ON_THE_GO_TOURS: {
    name: "On the Go Tours",
    id: "6138088f-1080-4857-9b48-d3a8443e2471",
    address: "3 Shortlands, London W6 8DA, United Kingdom"
  },
  OPENFERRY: {
    name: "Openferry",
    id: "16bf221a-684e-4ae8-843b-fb4e2c58cdae",
    address: "12 Earls Court Gardens, London, SW5 0TD"
  },
  ORBIX: {
    name: "Orbix",
    id: "3d569a4c-f2ff-4174-a187-d28037ee76b1",
    address: "Revolu\u010Dn\xED 767/25, 110 00 Praha 1 Czech Republic"
  },
  ORBZII: {
    name: "Orbzii",
    id: "3dc0aaea-6ee1-4aef-a6c6-803ce1e02b71",
    address: ""
  },
  OVO_NETWORK: {
    name: "OVO Network",
    id: "f1394a41-475e-5a62-9eb7-07cc830ab6bb",
    address: "71-75 Shelton Street, Covent Garden, WC2H 9JQ, London, United Kingdom"
  },
  PACK_YOUR_BAGS: {
    name: "Pack your Bags",
    id: "8897a0cd-11b6-4a11-a9b0-32a7a1fa9abc",
    address: "8 Boulevard Lelasseur 44100 Nantes"
  },
  PARIS_BASKETBALL: {
    name: "Paris Basketball",
    id: "1bf70196-53f1-4894-9782-f53ab074a26f",
    address: "HALLE GEORGES CARPENTIER 81 BD MASSENA 75013 PARIS 13"
  },
  PELIKAN: {
    name: "Pelikan",
    id: "fc5431df-d2bd-4bf6-b113-9a5148212354",
    address: "N\xE1mestie SNP 6, 811 06 Bratislava, Slovak Republic"
  },
  PELIKAN_PURCHASE_FUNNEL: {
    name: "Pelikan Purchase Funnel",
    id: "f8331dd7-20aa-4364-84c9-352ff9c95849",
    address: ""
  },
  PELIPECKY_PURCHASE_FUNNEL: {
    name: "Pelipecky Purchase Funnel",
    id: "c26b6500-712c-41f7-a240-3496cc0600de",
    address: ""
  },
  PLANIT: {
    name: "Planit",
    id: "17278555-ade5-4d1a-abf1-4daccb5b2352",
    address: ""
  },
  PSG: {
    name: "PSG",
    id: "39dddb7c-3dee-4870-862f-e59a0c39f49c",
    address: "24, rue du Commandant Guilbaud, 75016 Paris"
  },
  PARIS_FC: {
    name: "Paris FC",
    id: "dcb41e39-382f-4de8-bc2d-0bf2f26a43e8",
    address: "Voie des Saules, 94310 Orly, France"
  },
  LES_GETS: {
    name: "Les Gets",
    id: "961a34fa-488e-4407-b4c8-5d038732db22",
    address: "61 route du Front de Neige, 74260 Les Gets, France"
  },
  OCG_NICE: {
    name: "OGC Nice",
    id: "a827e736-a244-413f-83df-9e896a1b2332",
    address: "19, boulevard Jean Luciano, 06200 Nice, France"
  },
  RC_LENS: {
    name: "RC Lens",
    id: "aebfcbe6-6e9d-4c4a-bc3b-887b79d70f1c",
    address: "1 rue Maurice Carton, 62300 Lens, France"
  },
  RC_STRASBOURG: {
    name: "RC Strasbourg",
    id: "9b710150-f000-476e-9dd9-3e6249505d95",
    address: "12, rue de l'Extenwoerth, 67100 Strasbourg, France"
  },
  RAIL_EUROPE: {
    name: "Rail Europe",
    id: "12e05282-043e-4d0d-84fb-12059b344eca",
    address: "52 Rue de la Victoire \u2013 75009 Paris - FRANCE"
  },
  RAIL_EUROPE_B2B: {
    name: "Rail Europe B2B",
    id: "bd097991-d6c4-419d-9558-3999a20b69d6",
    address: "52 Rue de la Victoire \u2013 75009 Paris - FRANCE"
  },
  RC_TOULON: {
    name: "RC Toulon",
    id: "eaa93649-1321-4014-b19e-8ee17fa8a67b",
    address: "Vieux Chemin de Sainte-Musse, 83100 Toulon, France"
  },
  REVOLUGO: {
    name: "Revolugo",
    id: "ba8bf4d9-fbd8-41cc-a2d4-a4a9e1a91bd5",
    address: "5 avenue du G\xE9n\xE9ral de Gaulle 94160 SAINT-MANDE, France"
  },
  ROLEX_PARIS_MASTER: {
    name: "Rolex Paris Master",
    id: "d89c4103-3be8-417b-9eb2-c1033249ef70",
    address: "99 Jardins de l'Arche, 92000 Nanterre, France"
  },
  ROYAL_SITTER: {
    name: "Royal Sitter",
    id: "0da9a222-c7fe-43ee-acf3-dcb4103d5f90",
    address: "38 Bis boulevard Victor Hugo, Nice 06000"
  },
  SHEN_YUN_SPAIN: {
    name: "Shen Yun Spain",
    id: "835e2971-ff4d-4f74-bca6-b4a4884a32df",
    address: "23 AV FRANKLIN ROOSEVELT 77300 FONTAINEBLEAU"
  },
  SKI_PLANET: {
    name: "Ski Planet",
    id: "a2a53a8e-a12e-50d4-b296-5fde9ccd84f2",
    address: "575 rue de la Prairie - 73350 BOZEL - France"
  },
  SKY_TOURS: {
    name: "Sky-Tours",
    id: "2b502149-c77d-5892-9214-f1735564c29e",
    address: "Paseo de las Delicias 30, 7a planta de la localidad de Madrid, 28045, Spain"
  },
  SMARTWAY: {
    name: "Smartway",
    id: "4259f769-f1c7-4478-8cc9-96ade3c15c4e",
    address: "Via dell'Opio nel corso 11, 53045 Montepulciano (SI), Italy"
  },
  SO_VILLAS: {
    name: "So Villas",
    id: "ff43f12c-15e1-4ae3-a0b2-1dfc874887b9",
    address: "8 RUE DU FAUBOURG POISSONNIERE, 75010 PARIS"
  },
  SO_VILLAS_BOISSIERE: {
    name: "So Villas Boissi\xE8re",
    id: "7ae8a1d0-4d5f-455e-916d-02def3ca27e7",
    address: ""
  },
  SO_VILLAS_MESSAGERIE: {
    name: "So Villas Messagerie",
    id: "391c10e0-2b33-44ad-ab89-8388c6929027",
    address: ""
  },
  SO_VILLAS_PONCIN: {
    name: "So Villas Poncin",
    id: "b51cf5b6-e8d4-49ce-bf3c-b4d0f50a0e33",
    address: ""
  },
  STADE_BRESTOIS: {
    name: "Stade Brestois",
    id: "d4c96cbb-b2e8-4040-a7c2-fee2f27eae6e",
    address: "Centre de l'Armoricaine 6 chemin de Pen Helen 29200 Brest"
  },
  STADE_TOULOUSAIN: {
    name: "Stade Toulousain",
    id: "10a47bf3-92ae-4ee2-a59f-07afa5d8b156",
    address: "114 Rue des Tro\xE8nes 31200 Toulouse"
  },
  STADE_FRANCAIS_PARIS: {
    name: "Stade Fran\xE7ais Paris",
    id: "81eb30ac-57d2-4fab-8548-57a0d36ec85c",
    address: "20-40 avenue du G\xE9n\xE9ral Sarrail, 75016 Paris"
  },
  STADE_RENNAIS: {
    name: "Stade Rennais",
    id: "f2f2d96c-4485-4233-b3ce-131bc25ae0e2",
    address: "111 route de Lorient, 35000 Rennes"
  },
  STUDENT_AGENCY: {
    name: "Student Agency",
    id: "1ac8945f-14af-4903-b6df-b3c0fa165540",
    address: "N\xE1m\u011Bst\xED Svobody 86/17, Brno-m\u011Bsto, 602 00 Brno Czech Republic"
  },
  SUPER_TRIPPER: {
    name: "Super Tripper",
    id: "22e0f30a-7789-4f6e-ba6c-d1c5dc165148",
    address: ""
  },
  THE_FANZONE: {
    name: "The Fanzone",
    id: "694e0c4a-356f-4dcc-ad4f-e1bdc0962396",
    address: ""
  },
  TICKETSTOINDIA: {
    name: "TicketsToIndia",
    id: "d4bb479b-8930-4046-91e2-dfd5c2081d92",
    address: "Lily House, 11 the shrubberies, George lane, London, E18 1BD, United Kingdom"
  },
  TOULOUSE_FC: {
    name: "Toulouse FC",
    id: "3ef9b6d3-c78a-4e01-84ea-532edf442b90",
    address: "1 bis, all\xE9es Gabriel Bienes, 31028 Toulouse"
  },
  TRAVELGO: {
    name: "Travelgo",
    id: "40f5ec3f-fccc-4501-81c4-3574a322a99f",
    address: "71 Lower Baggot street, Dublin, D02P593"
  },
  TRAVELWORLD: {
    name: "travelWorld",
    id: "e31ee0ff-5184-4124-a2b9-2e80c5e91c4c",
    address: "Kolingasse 12/8, 1090 Vienna, Austria"
  },
  TRAVEL_CREATORS: {
    name: "Travel Creators",
    id: "a15cd7b2-da3c-4098-a021-5b6a3c5277fb",
    address: "Northcliffe House Young Street, Kensington, London, United Kingdom, W8 5EH"
  },
  TRAVEO: {
    name: "Traveo",
    id: "fd150bdf-6f4b-5cc8-9c15-2d8f03b5db57",
    address: "Krist\xEDnargata 1, 102 Reykjav\xEDk, Islande"
  },
  TRYP: {
    name: "Tryp",
    id: "9881aded-3488-421b-82ec-7baa0f542834",
    address: "Cortex Park 26, 523 Odense \u2013 Denmark"
  },
  TUI_GERMANY: {
    name: "Tui Germany",
    id: "421a8416-680d-4ef4-8664-2b6d0bc15b80",
    address: "Karl-Wiechert-Allee 23, 30625 Hanover, Germany"
  },
  TURQUOISE_VOYAGES: {
    name: "Turquoise Voyages",
    id: "56af850e-96e6-57ba-9b8b-9229b039b6ad",
    address: "8 rue Neuve Saint-Martin 13001 Marseille"
  },
  ULYSSE: {
    name: "Ulysse",
    id: "cf9f7a33-ab13-43ad-97d5-55bc76ca2812",
    address: "3 chemin du Moulin - 77610 Marles-en-Brie"
  },
  VAL_THORENS: {
    name: "Val Thorens",
    id: "673dfe82-40e0-4139-909e-1b66464c2c35",
    address: "Maison de Val Thorens \u2013 588 Grande Rue \u2013 73440 Les Belleville"
  },
  VERSO: {
    name: "Verso",
    id: "b42fc3de-0615-4a99-9d89-01647708cd11",
    address: ""
  },
  VIPPER: {
    name: "Vipper",
    id: "d9048162-239a-4475-a35a-e635c53ae094",
    address: "Herengracht 184 B, 1016BS Amsterdam, Netherlands"
  },
  VOLA: {
    name: "Vola",
    id: "8eff576e-1349-4a48-98c5-f23861096e5e",
    address: "Splaiul Unirii 165, TN Offices 2 Building, 2nd Floor, Sector 3, Bucharest, Romania"
  },
  VOLARIO: {
    name: "Volario",
    id: "1b47f369-925b-463f-88ae-8c73b005cca4",
    address: "Warschauer Pl. 11-13 10245 Berlin Germany"
  },
  VOLOTEA: {
    name: "Volotea",
    id: "c941a120-3258-49e2-ae30-e8e2a7aaf775",
    address: "Travessera de Gracia 56, 4\xAA. 08006 - Barcelona"
  },
  WECO: {
    name: "Weco",
    id: "a8911e32-bb8e-4356-89ba-ca1ed58a7a73",
    address: "Al. Jana Pawla II 19, 00-854 Warsaw, Poland"
  },
  WEEKEND_FOOT: {
    name: "Weekend Foot",
    id: "f644f6c4-137c-4f48-aa86-0292d3286e92",
    address: "195 CHEMIN DE NEYRON 69140 RILLIEUX-LA-PAPE"
  },
  WEEKENDESK: {
    name: "Weekendesk",
    id: "86ec9d59-2556-421a-9392-c915761bebce",
    address: "28 Rue de Londres 75009 Paris"
  },
  WORLDIA: {
    name: "Worldia",
    id: "2adf6b22-f685-45f8-b796-d65c9e0fc955",
    address: "86 rue Voltaire 93100 Montreuil"
  },
  // Test partners
  SUPER_COMPANY: {
    name: "Super Company",
    id: "69254560-7e0c-484a-a06e-03d87d31f5ca",
    address: ""
  },
  TEST_PARTNER: {
    name: "Test partner",
    id: "97c7886c-b1f1-48cb-b2a5-a9bc221818a1",
    address: ""
  }
};
var PARTNER_IDS_WITH_CUMULATIVE_CLAIMS_ON_ANNUAL_SUBSCRIPTIONS = [
  PARTNERS.AS_MONACO.id,
  PARTNERS.EPCR.id,
  PARTNERS.FC_NANTES.id,
  PARTNERS.PARIS_BASKETBALL.id,
  PARTNERS.PARIS_FC.id,
  PARTNERS.STADE_BRESTOIS.id,
  PARTNERS.STADE_FRANCAIS_PARIS.id,
  PARTNERS.STADE_RENNAIS.id,
  PARTNERS.TOULOUSE_FC.id,
  PARTNERS.ASSE.id
];

// src/facts/product-pricing-overview/select-default-currency.ts
function selectDefaultCurrencySettings(perCurrencySettings) {
  if ("EUR" in perCurrencySettings) {
    return {
      currency: "EUR",
      settings: perCurrencySettings.EUR
    };
  }
  if ("GBP" in perCurrencySettings) {
    return {
      currency: "GBP",
      settings: perCurrencySettings.GBP
    };
  }
  const arbitraryDefaultCurrency = Object.keys(perCurrencySettings)[0];
  return {
    currency: arbitraryDefaultCurrency,
    settings: perCurrencySettings[arbitraryDefaultCurrency]
  };
}
__name(selectDefaultCurrencySettings, "selectDefaultCurrencySettings");

// src/facts/product-pricing-overview/product-pricing-overview.facts.ts
function isInsuranceProduct(productType) {
  return [
    ProductTypeEnum4.COMPREHENSIVE,
    ProductTypeEnum4.FLIGHT_DISRUPTION
  ].includes(productType);
}
__name(isInsuranceProduct, "isInsuranceProduct");
function isFixedPricingProduct(settings) {
  return settings.pricingSettings.type === PriceSettingTypeEnum4.FIXED || settings.pricingSettings.type === PriceSettingTypeEnum4.COEFFICIENT && settings.pricingSettings.coefficientProperty === ProductPricingSettingCoefficientPropertyEnum3.TRIP_DURATION;
}
__name(isFixedPricingProduct, "isFixedPricingProduct");
function getExternalPricingProvider(pricingProvider) {
  return pricingProvider !== ProductPricingProviderEnum.KOALA ? pricingProvider : null;
}
__name(getExternalPricingProvider, "getExternalPricingProvider");
function calculateTaxes({ productType, premium, koalaCommission, partnerCountry, productProvider, productCreationDate }) {
  if (isInsuranceProduct(productType)) {
    if (productProvider === ProductProviderEnum.MEETCH) {
      return {
        serviceTaxes: 0,
        insuranceTaxes: 0,
        totalTaxes: 0
      };
    }
    const insuranceTaxRate = partnerCountry.insuranceTax ?? 0;
    const insuranceTaxes2 = (premium + koalaCommission) * insuranceTaxRate;
    return {
      serviceTaxes: 0,
      insuranceTaxes: insuranceTaxes2,
      totalTaxes: insuranceTaxes2
    };
  }
  const serviceTaxRate = partnerCountry.serviceTax ?? 0;
  if (productCreationDate < LEGACY_PRICER_MIGRATION_DATE) {
    const serviceTaxes2 = (premium + koalaCommission) * serviceTaxRate;
    return {
      serviceTaxes: serviceTaxes2,
      insuranceTaxes: 0,
      totalTaxes: serviceTaxes2
    };
  }
  const serviceTaxes = koalaCommission * serviceTaxRate;
  const insuranceTaxes = premium * FRENCH_IPT_RATE;
  return {
    serviceTaxes,
    insuranceTaxes,
    totalTaxes: insuranceTaxes + serviceTaxes
  };
}
__name(calculateTaxes, "calculateTaxes");
function getFixedPricingOverview(defaultSettings, country) {
  const gnwp = defaultSettings.settings.pricingSettings.value;
  const koalaCommissionFixed = defaultSettings.settings.commissionSettings.koala.fixedValue ?? 0;
  const partnerCommissionFixed = defaultSettings.settings.commissionSettings.partner.fixedValue ?? 0;
  const insuranceTaxRate = country.insuranceTax ?? 0;
  const insuranceTaxes = (gnwp + koalaCommissionFixed + partnerCommissionFixed) * insuranceTaxRate;
  const retailPriceFixed = gnwp + koalaCommissionFixed + partnerCommissionFixed + insuranceTaxes;
  return {
    currency: defaultSettings.currency,
    pricingBase: "TRIP_PRICE",
    premium: null,
    retailPriceCoefficient: null,
    retailPriceFixed,
    retailPriceExternal: null,
    retailPriceProvidedByPartner: false,
    insurerCommission: null,
    koalaCommission: koalaCommissionFixed > 0 ? koalaCommissionFixed : null,
    koalaCommissionCoefficient: null,
    koalaCommissionFixed: koalaCommissionFixed > 0 ? koalaCommissionFixed : null,
    partnerCommission: partnerCommissionFixed > 0 ? partnerCommissionFixed : null,
    partnerCommissionCoefficient: null,
    partnerCommissionFixed: partnerCommissionFixed > 0 ? partnerCommissionFixed : null,
    taxes: insuranceTaxes > 0 ? insuranceTaxes : null,
    serviceTaxes: null,
    insuranceTaxes: insuranceTaxes > 0 ? insuranceTaxRate : null,
    businessContributorCommission: null
  };
}
__name(getFixedPricingOverview, "getFixedPricingOverview");
function getExternalPricingOverview(defaultSettings, pricingProvider) {
  return {
    currency: defaultSettings.currency,
    pricingBase: "TRIP_PRICE",
    premium: null,
    retailPriceCoefficient: null,
    retailPriceFixed: calculateRetailPriceAsFixedAmount(defaultSettings.settings),
    retailPriceExternal: getExternalPricingProvider(pricingProvider),
    retailPriceProvidedByPartner: false,
    insurerCommission: null,
    koalaCommission: null,
    koalaCommissionCoefficient: null,
    koalaCommissionFixed: null,
    partnerCommission: null,
    partnerCommissionCoefficient: null,
    partnerCommissionFixed: null,
    taxes: null,
    serviceTaxes: null,
    insuranceTaxes: null,
    businessContributorCommission: null
  };
}
__name(getExternalPricingOverview, "getExternalPricingOverview");
var COMMISSION_PROPERTY_FOR_BASE = {
  TRIP_PRICE: ProductCommissionSettingCoefficientPropertyEnum.TRIP_PRICE,
  NON_REFUNDABLE_TRIP_PRICE: ProductCommissionSettingCoefficientPropertyEnum.NON_REFUNDABLE_TRIP_PRICE
};
function areCommissionsExpressibleOnBase(commissionSettings, base) {
  return Object.values(commissionSettings).every((setting) => setting.coefficientProperty === ProductCommissionSettingCoefficientPropertyEnum.GROSS_NET_WRITTEN_PREMIUM || setting.coefficientProperty === COMMISSION_PROPERTY_FOR_BASE[base]);
}
__name(areCommissionsExpressibleOnBase, "areCommissionsExpressibleOnBase");
function resolveCommissionAsRatioOfBase(setting, value, premiumAsRatioOfBase, base) {
  if (setting.coefficientProperty === ProductCommissionSettingCoefficientPropertyEnum.GROSS_NET_WRITTEN_PREMIUM) {
    return premiumAsRatioOfBase * value;
  }
  if (setting.coefficientProperty === COMMISSION_PROPERTY_FOR_BASE[base]) {
    return value;
  }
  throw new Error(`A commission based on "${setting.coefficientProperty}" cannot be expressed as a ratio of "${base}".`);
}
__name(resolveCommissionAsRatioOfBase, "resolveCommissionAsRatioOfBase");
function getCoefficientPricingOverview(defaultSettings, country, product, premium, base) {
  const { commissionSettings } = defaultSettings.settings;
  const koalaCommission = resolveCommissionAsRatioOfBase(commissionSettings.koala, commissionSettings.koala.value, premium, base);
  const koalaCommissionCoefficient = commissionSettings.koala.coefficientValue !== void 0 ? resolveCommissionAsRatioOfBase(commissionSettings.koala, commissionSettings.koala.coefficientValue, premium, base) : null;
  const koalaCommissionFixed = commissionSettings.koala.fixedValue ?? null;
  const partnerCommission = resolveCommissionAsRatioOfBase(commissionSettings.partner, commissionSettings.partner.value, premium, base);
  const partnerCommissionCoefficient = commissionSettings.partner.coefficientValue !== void 0 ? resolveCommissionAsRatioOfBase(commissionSettings.partner, commissionSettings.partner.coefficientValue, premium, base) : null;
  const partnerCommissionFixed = commissionSettings.partner.fixedValue ?? null;
  const insurerCommission = resolveCommissionAsRatioOfBase(commissionSettings.insurer, commissionSettings.insurer.value, premium, base);
  const { serviceTaxes, insuranceTaxes, totalTaxes } = calculateTaxes({
    productType: product.type,
    partnerCountry: country,
    premium,
    koalaCommission,
    insurerCommission,
    productCreationDate: product.createdAt,
    productProvider: product.provider
  });
  const total = premium + koalaCommission + partnerCommission + insurerCommission + totalTaxes;
  const businessContributorCommission = total * (product.businessContributorCommissionRatio ?? 0);
  const brokerageFees = total * (product.brokerageFeesRatio ?? 0);
  const retailPriceCoefficient = total + businessContributorCommission + brokerageFees;
  return {
    currency: defaultSettings.currency,
    pricingBase: base,
    premium,
    retailPriceCoefficient,
    retailPriceFixed: calculateRetailPriceAsFixedAmount(defaultSettings.settings),
    retailPriceExternal: getExternalPricingProvider(product.pricingProvider),
    retailPriceProvidedByPartner: false,
    insurerCommission,
    koalaCommission,
    partnerCommission,
    partnerCommissionCoefficient,
    partnerCommissionFixed,
    koalaCommissionCoefficient,
    koalaCommissionFixed,
    taxes: totalTaxes,
    serviceTaxes,
    insuranceTaxes,
    businessContributorCommission
  };
}
__name(getCoefficientPricingOverview, "getCoefficientPricingOverview");
function getCarTrawlerPartnerPricingOverview(defaultSettings) {
  const { commissionSettings, pricingSettings } = defaultSettings.settings;
  const premium = pricingSettings.value;
  return {
    currency: defaultSettings.currency,
    pricingBase: "TRIP_PRICE",
    premium,
    retailPriceCoefficient: null,
    retailPriceFixed: null,
    retailPriceExternal: null,
    retailPriceProvidedByPartner: true,
    koalaCommission: commissionSettings.koala.value,
    koalaCommissionCoefficient: commissionSettings.koala.coefficientValue ?? null,
    koalaCommissionFixed: commissionSettings.koala.fixedValue ?? null,
    partnerCommission: commissionSettings.partner.value,
    partnerCommissionCoefficient: commissionSettings.partner.coefficientValue ?? null,
    partnerCommissionFixed: commissionSettings.partner.fixedValue ?? null,
    insurerCommission: null,
    businessContributorCommission: null,
    taxes: premium * FRENCH_IPT_RATE,
    serviceTaxes: null,
    insuranceTaxes: FRENCH_IPT_RATE
  };
}
__name(getCarTrawlerPartnerPricingOverview, "getCarTrawlerPartnerPricingOverview");
function getCarTrawlerApiPricingOverview(defaultSettings, country, product) {
  const { commissionSettings, pricingSettings } = defaultSettings.settings;
  const premium = pricingSettings.value;
  const serviceTaxRate = country.serviceTax ?? 0;
  return {
    currency: defaultSettings.currency,
    pricingBase: "TRIP_PRICE",
    premium,
    retailPriceCoefficient: null,
    retailPriceFixed: null,
    retailPriceExternal: ProductPricingProviderEnum.CARTRAWLER,
    retailPriceProvidedByPartner: false,
    koalaCommission: commissionSettings.koala.value,
    koalaCommissionCoefficient: commissionSettings.koala.coefficientValue ?? null,
    koalaCommissionFixed: commissionSettings.koala.fixedValue ?? null,
    partnerCommission: commissionSettings.partner.value,
    partnerCommissionCoefficient: commissionSettings.partner.coefficientValue ?? null,
    partnerCommissionFixed: commissionSettings.partner.fixedValue ?? null,
    insurerCommission: commissionSettings.insurer.value,
    businessContributorCommission: product.businessContributorCommissionRatio ?? null,
    taxes: premium * FRENCH_IPT_RATE + serviceTaxRate,
    serviceTaxes: serviceTaxRate,
    insuranceTaxes: FRENCH_IPT_RATE
  };
}
__name(getCarTrawlerApiPricingOverview, "getCarTrawlerApiPricingOverview");
function getBattlefacePricingOverview(defaultSettings, country) {
  const { commissionSettings } = defaultSettings.settings;
  const insuranceTaxRate = country.insuranceTax ?? 0;
  return {
    currency: defaultSettings.currency,
    pricingBase: "TRIP_PRICE",
    premium: null,
    retailPriceCoefficient: null,
    retailPriceFixed: null,
    retailPriceExternal: null,
    retailPriceProvidedByPartner: false,
    koalaCommission: commissionSettings.koala.value,
    koalaCommissionCoefficient: commissionSettings.koala.coefficientValue ?? null,
    koalaCommissionFixed: commissionSettings.koala.fixedValue ?? null,
    partnerCommission: commissionSettings.partner.value,
    partnerCommissionCoefficient: commissionSettings.partner.coefficientValue ?? null,
    partnerCommissionFixed: commissionSettings.partner.fixedValue ?? null,
    insurerCommission: null,
    businessContributorCommission: null,
    taxes: null,
    serviceTaxes: null,
    insuranceTaxes: insuranceTaxRate > 0 ? insuranceTaxRate : null
  };
}
__name(getBattlefacePricingOverview, "getBattlefacePricingOverview");
function hasFixedPricingWithValue(settings) {
  return isFixedPricingProduct(settings) && settings.pricingSettings.value !== 0;
}
__name(hasFixedPricingWithValue, "hasFixedPricingWithValue");
function getFallbackPricingOverview(defaultSettings, country, pricingProvider) {
  if (hasFixedPricingWithValue(defaultSettings.settings)) {
    return getFixedPricingOverview(defaultSettings, country);
  }
  return getExternalPricingOverview(defaultSettings, pricingProvider);
}
__name(getFallbackPricingOverview, "getFallbackPricingOverview");
function getPremiumAsRatioOfNonRefundableTripPrice(settings) {
  if (settings.pricingSettings.type === PriceSettingTypeEnum4.COEFFICIENT && settings.pricingSettings.coefficientProperty === ProductPricingSettingCoefficientPropertyEnum3.NON_REFUNDABLE_TRIP_PRICE) {
    return settings.pricingSettings.value;
  }
  return null;
}
__name(getPremiumAsRatioOfNonRefundableTripPrice, "getPremiumAsRatioOfNonRefundableTripPrice");
function getNonRefundableTripPricePricingOverview(defaultSettings, country, product) {
  const premium = getPremiumAsRatioOfNonRefundableTripPrice(defaultSettings.settings);
  if (premium === null || !areCommissionsExpressibleOnBase(defaultSettings.settings.commissionSettings, "NON_REFUNDABLE_TRIP_PRICE")) {
    return null;
  }
  return getCoefficientPricingOverview(defaultSettings, country, product, premium, "NON_REFUNDABLE_TRIP_PRICE");
}
__name(getNonRefundableTripPricePricingOverview, "getNonRefundableTripPricePricingOverview");
(function(ProductPricingOverviewFacts2) {
  function getProductPricingOverview(product, country) {
    const defaultSettings = selectDefaultCurrencySettings(product.perCurrencySettings);
    if (product.pricingProvider === ProductPricingProviderEnum.CARTRAWLER) {
      return getCarTrawlerApiPricingOverview(defaultSettings, country, product);
    }
    if (product.partnerId === PARTNERS.CARTRAWLER.id) {
      return getCarTrawlerPartnerPricingOverview(defaultSettings);
    }
    if (product.provider === ProductProviderEnum.BATTLEFACE) {
      return getBattlefacePricingOverview(defaultSettings, country);
    }
    const nonRefundableOverview = getNonRefundableTripPricePricingOverview(defaultSettings, country, product);
    if (nonRefundableOverview !== null) {
      return nonRefundableOverview;
    }
    const premium = calculatePremiumAsPercentageOfBookingPrice(defaultSettings.settings);
    if (premium === null || !areCommissionsExpressibleOnBase(defaultSettings.settings.commissionSettings, "TRIP_PRICE")) {
      return getFallbackPricingOverview(defaultSettings, country, product.pricingProvider);
    }
    return getCoefficientPricingOverview(defaultSettings, country, product, premium, "TRIP_PRICE");
  }
  __name(getProductPricingOverview, "getProductPricingOverview");
  ProductPricingOverviewFacts2.getProductPricingOverview = getProductPricingOverview;
})(ProductPricingOverviewFacts || (ProductPricingOverviewFacts = {}));
var ProductPricingOverviewFacts;

// src/facts/product-providers/wakam.ts
import { DateTime as DateTime3 } from "luxon";
import { WakamPartnershipCodeEnum } from "@repo/lib-koala-types";
(function(Wakam2) {
  function getPartnershipCodeFromCountryCode(countryId) {
    const code = WakamPartnershipCodeEnum[countryId];
    if (code === void 0) {
      throw new Error(`No partnership for country: ${countryId}`);
    }
    return code;
  }
  __name(getPartnershipCodeFromCountryCode, "getPartnershipCodeFromCountryCode");
  Wakam2.getPartnershipCodeFromCountryCode = getPartnershipCodeFromCountryCode;
  function getCountryCodeFromPartnershipCode(code) {
    const keys = Object.keys(WakamPartnershipCodeEnum);
    const countryId = keys.find((key) => WakamPartnershipCodeEnum[key] === code);
    if (countryId === void 0) {
      throw new Error(`No country id for partnership code: ${code}`);
    }
    return countryId;
  }
  __name(getCountryCodeFromPartnershipCode, "getCountryCodeFromPartnershipCode");
  Wakam2.getCountryCodeFromPartnershipCode = getCountryCodeFromPartnershipCode;
  function getFastDataExportDefaultDate() {
    return DateTime3.utc().minus({
      month: 1
    }).endOf("month");
  }
  __name(getFastDataExportDefaultDate, "getFastDataExportDefaultDate");
  Wakam2.getFastDataExportDefaultDate = getFastDataExportDefaultDate;
  function getFastDataPoliciesExportFilename(partnershipCode, exportDate = getFastDataExportDefaultDate()) {
    return `FD_KOALA_${partnershipCode}_Policies_${exportDate.toFormat("yyyyMMdd")}.csv`;
  }
  __name(getFastDataPoliciesExportFilename, "getFastDataPoliciesExportFilename");
  Wakam2.getFastDataPoliciesExportFilename = getFastDataPoliciesExportFilename;
  function getFastDataClaimsExportFilename(partnershipCode, exportDate = getFastDataExportDefaultDate()) {
    return `FD_KOALA_${partnershipCode}_Claims_${exportDate.toFormat("yyyyMMdd")}.csv`;
  }
  __name(getFastDataClaimsExportFilename, "getFastDataClaimsExportFilename");
  Wakam2.getFastDataClaimsExportFilename = getFastDataClaimsExportFilename;
  function getFastDataReceiptExportFilename(partnershipCode, exportDate = getFastDataExportDefaultDate()) {
    return `FD_KOALA_${partnershipCode}_Receipts_${exportDate.toFormat("yyyyMMdd")}.csv`;
  }
  __name(getFastDataReceiptExportFilename, "getFastDataReceiptExportFilename");
  Wakam2.getFastDataReceiptExportFilename = getFastDataReceiptExportFilename;
  function isValidPartnershipCountry(key) {
    return key !== void 0 && Object.keys(WakamPartnershipCodeEnum).includes(key);
  }
  __name(isValidPartnershipCountry, "isValidPartnershipCountry");
  Wakam2.isValidPartnershipCountry = isValidPartnershipCountry;
})(Wakam || (Wakam = {}));
var Wakam;

// src/facts/seyna-binders/seyna-binder.facts.ts
import { SeynaBinders as SeynaBinders6 } from "@repo/lib-koala-types";

// src/facts/seyna-binders/seyna-car-rental.rule.ts
import { SeynaBinders } from "@repo/lib-koala-types";
var seynaCarRentalRule = {
  binder: SeynaBinders.CAR_RENTAL,
  matches: /* @__PURE__ */ __name(({ partnerId }) => partnerId === PARTNERS.CARTRAWLER.id, "matches")
};

// src/facts/seyna-binders/seyna-change-for-any-reason.rule.ts
import { ProductTypeEnum as ProductTypeEnum5, SeynaBinders as SeynaBinders2 } from "@repo/lib-koala-types";
var ALL_WITHDRAWALS_PARTNER_IDS = [
  PARTNERS.VOLA.id,
  PARTNERS.FRU.id
];
var CHANGE_NAMED_WITHDRAWALS_PARTNER_IDS = [
  PARTNERS.PELIKAN.id,
  PARTNERS.PELIKAN_PURCHASE_FUNNEL.id
];
var CHANGE_PRODUCT_NAME_MARKER = "change";
function matches({ partnerId, productType, productName }) {
  if (productType === ProductTypeEnum5.CHANGE_FOR_ANY_REASON) {
    return true;
  }
  if (productType !== ProductTypeEnum5.WITHDRAWAL) {
    return false;
  }
  return ALL_WITHDRAWALS_PARTNER_IDS.includes(partnerId) || CHANGE_NAMED_WITHDRAWALS_PARTNER_IDS.includes(partnerId) && productName.toLowerCase().includes(CHANGE_PRODUCT_NAME_MARKER);
}
__name(matches, "matches");
var seynaChangeForAnyReasonRule = {
  binder: SeynaBinders2.CHANGE_FOR_ANY_REASON,
  matches
};

// src/facts/seyna-binders/seyna-flex.rule.ts
import { SeynaBinders as SeynaBinders4 } from "@repo/lib-koala-types";

// src/facts/seyna-binders/seyna-high-value-booking.rule.ts
import { SeynaBinders as SeynaBinders3 } from "@repo/lib-koala-types";
var COMPENSATION_THRESHOLD_IN_EUR = 7e3;
function isBelowHighValueBookingThreshold({ compensationAmountInEur }) {
  return compensationAmountInEur !== null && compensationAmountInEur < COMPENSATION_THRESHOLD_IN_EUR;
}
__name(isBelowHighValueBookingThreshold, "isBelowHighValueBookingThreshold");
var seynaHighValueBookingRule = {
  binder: SeynaBinders3.HIGH_VALUE_BOOKING,
  matches: /* @__PURE__ */ __name(({ compensationAmountInEur }) => compensationAmountInEur !== null && compensationAmountInEur >= COMPENSATION_THRESHOLD_IN_EUR, "matches")
};

// src/facts/seyna-binders/seyna-flex.rule.ts
var FLEX_80_MAXIMUM_REFUND_RATE_PERCENTAGE = 80;
var FLEX_90_MAXIMUM_REFUND_RATE_PERCENTAGE = 90;
function toRefundRatePercentage(compensationCoefficient) {
  return Math.round(compensationCoefficient * 100);
}
__name(toRefundRatePercentage, "toRefundRatePercentage");
function hasRefundRateWithin(input, { above, upTo }) {
  if (input.compensationCoefficient === null) {
    return false;
  }
  const refundRatePercentage = toRefundRatePercentage(input.compensationCoefficient);
  return (above === null || refundRatePercentage > above) && refundRatePercentage <= upTo;
}
__name(hasRefundRateWithin, "hasRefundRateWithin");
function createFlexRule(binder, range) {
  return {
    binder,
    matches: /* @__PURE__ */ __name((input) => isBelowHighValueBookingThreshold(input) && hasRefundRateWithin(input, range), "matches")
  };
}
__name(createFlexRule, "createFlexRule");
var seynaFlex90Rule = createFlexRule(SeynaBinders4.FLEX_90, {
  above: FLEX_80_MAXIMUM_REFUND_RATE_PERCENTAGE,
  upTo: FLEX_90_MAXIMUM_REFUND_RATE_PERCENTAGE
});
var seynaFlex80Rule = createFlexRule(SeynaBinders4.FLEX_80, {
  above: null,
  upTo: FLEX_80_MAXIMUM_REFUND_RATE_PERCENTAGE
});

// src/facts/seyna-binders/seyna-omio-semi-refundable.rule.ts
import { SeynaBinders as SeynaBinders5 } from "@repo/lib-koala-types";
var SEMI_REFUNDABLE_PRODUCT_NAME_MARKER = "semi";
var seynaOmioSemiRefundableRule = {
  binder: SeynaBinders5.OMIO_SEMI_REFUNDABLE,
  matches: /* @__PURE__ */ __name(({ partnerId, productName }) => partnerId === PARTNERS.OMIO.id && productName.toLowerCase().includes(SEMI_REFUNDABLE_PRODUCT_NAME_MARKER), "matches")
};

// src/facts/seyna-binders/seyna-binder-rules.ts
var SEYNA_BINDER_RULES = [
  seynaCarRentalRule,
  seynaChangeForAnyReasonRule,
  seynaOmioSemiRefundableRule,
  seynaHighValueBookingRule,
  seynaFlex90Rule,
  seynaFlex80Rule
];

// src/facts/seyna-binders/seyna-binder.facts.ts
var SEYNA_EXPORTABLE_BINDERS = [
  ...SEYNA_BINDER_RULES.map((rule) => rule.binder),
  SeynaBinders6.OTHERS
];
(function(SeynaBinderFacts2) {
  function getBinder(input) {
    return SEYNA_BINDER_RULES.find((rule) => rule.matches(input))?.binder ?? SeynaBinders6.OTHERS;
  }
  __name(getBinder, "getBinder");
  SeynaBinderFacts2.getBinder = getBinder;
})(SeynaBinderFacts || (SeynaBinderFacts = {}));
var SeynaBinderFacts;

// src/facts/subscription.facts.ts
import { DateTime as DateTime4 } from "luxon";
(function(SubscriptionFacts2) {
  function getEligibilityCutoff(tripStartDate, contracts) {
    if (contracts.length === 0) {
      return null;
    }
    const contractsEligibilityCutoffs = contracts.map(({ minimumPeriodBeforeStart }) => ContractFacts.getEligibilityCutoff(tripStartDate, minimumPeriodBeforeStart));
    return DateTime4.min(...contractsEligibilityCutoffs);
  }
  __name(getEligibilityCutoff, "getEligibilityCutoff");
  SubscriptionFacts2.getEligibilityCutoff = getEligibilityCutoff;
})(SubscriptionFacts || (SubscriptionFacts = {}));
var SubscriptionFacts;

// src/facts/subscription-payment.ts
import { ApexxPaymentStatuses, StripePaymentIntentStatuses, SubscriptionPaymentStatuses, SubscriptionPaymentTypes } from "@repo/lib-koala-types";
var APEXX_PAYMENT_STATUS_TO_SUBSCRIPTION_PAYMENT_STATUS = {
  [ApexxPaymentStatuses.CAPTURED]: SubscriptionPaymentStatuses.COMPLETED,
  [ApexxPaymentStatuses.SETTLED]: SubscriptionPaymentStatuses.COMPLETED,
  [ApexxPaymentStatuses.DECLINED]: SubscriptionPaymentStatuses.DECLINED,
  [ApexxPaymentStatuses.CANCELLED]: SubscriptionPaymentStatuses.DECLINED,
  [ApexxPaymentStatuses.AUTHENTICATED]: SubscriptionPaymentStatuses.FAILED,
  [ApexxPaymentStatuses.AUTHORISED]: SubscriptionPaymentStatuses.FAILED,
  [ApexxPaymentStatuses.TOKENISED]: SubscriptionPaymentStatuses.FAILED,
  [ApexxPaymentStatuses.REFUNDED]: SubscriptionPaymentStatuses.FAILED,
  [ApexxPaymentStatuses.FAILED]: SubscriptionPaymentStatuses.FAILED,
  [ApexxPaymentStatuses.PENDING]: SubscriptionPaymentStatuses.FAILED,
  [ApexxPaymentStatuses.INVALID_REQUEST]: SubscriptionPaymentStatuses.FAILED,
  [ApexxPaymentStatuses.UNKNOWN]: SubscriptionPaymentStatuses.FAILED
};
var STRIPE_PAYMENT_INTENT_STATUS_TO_SUBSCRIPTION_PAYMENT_STATUS = {
  [StripePaymentIntentStatuses.SUCCEEDED]: SubscriptionPaymentStatuses.COMPLETED,
  [StripePaymentIntentStatuses.CANCELED]: SubscriptionPaymentStatuses.DECLINED,
  [StripePaymentIntentStatuses.REQUIRES_PAYMENT_METHOD]: SubscriptionPaymentStatuses.FAILED,
  [StripePaymentIntentStatuses.REQUIRES_CONFIRMATION]: SubscriptionPaymentStatuses.FAILED,
  [StripePaymentIntentStatuses.REQUIRES_ACTION]: SubscriptionPaymentStatuses.FAILED,
  [StripePaymentIntentStatuses.REQUIRES_CAPTURE]: SubscriptionPaymentStatuses.FAILED,
  [StripePaymentIntentStatuses.PROCESSING]: SubscriptionPaymentStatuses.FAILED
};
(function(SubscriptionPaymentFacts2) {
  function getStatus(payment) {
    switch (payment.type) {
      case SubscriptionPaymentTypes.APEXX:
        return APEXX_PAYMENT_STATUS_TO_SUBSCRIPTION_PAYMENT_STATUS[payment.apexxPaymentStatus];
      case SubscriptionPaymentTypes.STRIPE:
        return STRIPE_PAYMENT_INTENT_STATUS_TO_SUBSCRIPTION_PAYMENT_STATUS[payment.stripePaymentIntentStatus];
      // An operator only records these payments to settle the subscription, so they always complete it
      case SubscriptionPaymentTypes.MANUAL:
      case SubscriptionPaymentTypes.COMMERCIAL_GESTURE:
        return SubscriptionPaymentStatuses.COMPLETED;
      default:
        throw new Error("Cannot compute SubscriptionPaymentStatus from payment because type is unknown.");
    }
  }
  __name(getStatus, "getStatus");
  SubscriptionPaymentFacts2.getStatus = getStatus;
  function isCompleted(payment) {
    return getStatus(payment) === SubscriptionPaymentStatuses.COMPLETED;
  }
  __name(isCompleted, "isCompleted");
  SubscriptionPaymentFacts2.isCompleted = isCompleted;
  function isOperatorRecorded(type) {
    const IS_OPERATOR_RECORDED_MAPPING = {
      MANUAL: true,
      COMMERCIAL_GESTURE: true,
      APEXX: false,
      STRIPE: false
    };
    return IS_OPERATOR_RECORDED_MAPPING[type];
  }
  __name(isOperatorRecorded, "isOperatorRecorded");
  SubscriptionPaymentFacts2.isOperatorRecorded = isOperatorRecorded;
})(SubscriptionPaymentFacts || (SubscriptionPaymentFacts = {}));
var SubscriptionPaymentFacts;

// src/i18n-supported-languages.ts
var i18nEmailTemplatesLanguageTags = [
  "cs-CZ",
  "de-DE",
  "el-GR",
  "en-GB",
  "en-US",
  "es-ES",
  "fr-FR",
  "hu-HU",
  "it-IT",
  "nb-NO",
  "nl-NL",
  "pl-PL",
  "pt-PT",
  "sk-SK"
];
var i18nAirportCountriesTranslationLanguageCodes = [
  "cs",
  "de",
  "en",
  "fr",
  "hu",
  "pl",
  "sk",
  "vi"
];

// src/quote-expiration.ts
var MAX_QUOTE_EXPIRATION_DURATION_IN_DAYS = 15;

// src/taxes-calculator/taxes-calculator.service.ts
import { Decimal as Decimal3 } from "decimal.js";
import { FRENCH_IPT_RATE as FRENCH_IPT_RATE2, PRODUCTS_PRICED_BY_LEGACY_PRICERS } from "@repo/lib-koala-types";
var TaxesCalculatorService = class {
  static {
    __name(this, "TaxesCalculatorService");
  }
  static calculateTaxes(params) {
    const { productId, retailPremiumTaxesIncluded, grossNetWrittenPremium, distributionPartnerCommission, businessContributorCommission, insuranceTaxAmount, serviceTaxAmount, partnerCountryServiceTax } = params;
    if (PRODUCTS_PRICED_BY_LEGACY_PRICERS.includes(productId) === false) {
      const initialKoalaCommission = new Decimal3(retailPremiumTaxesIncluded).minus(grossNetWrittenPremium).minus(distributionPartnerCommission).minus(insuranceTaxAmount).minus(serviceTaxAmount).minus(businessContributorCommission);
      return {
        actualInsuranceTaxes: new Decimal3(insuranceTaxAmount),
        actualKoalaCommission: new Decimal3(initialKoalaCommission),
        actualServiceTaxes: new Decimal3(serviceTaxAmount)
      };
    }
    const actualInsuranceTaxes = new Decimal3(grossNetWrittenPremium).mul(FRENCH_IPT_RATE2);
    const initialKoalaCommissionAndServiceTaxes = new Decimal3(retailPremiumTaxesIncluded).minus(grossNetWrittenPremium).minus(actualInsuranceTaxes).minus(distributionPartnerCommission).minus(businessContributorCommission);
    const actualKoalaCommission = initialKoalaCommissionAndServiceTaxes.dividedBy(1 + partnerCountryServiceTax);
    const actualServiceTaxes = actualKoalaCommission.mul(partnerCountryServiceTax);
    return {
      actualInsuranceTaxes,
      actualKoalaCommission,
      actualServiceTaxes
    };
  }
};

// src/index.ts
export * from "@repo/lib-koala-types";
export {
  APEXX_PAYMENT_STATUS_TO_SUBSCRIPTION_PAYMENT_STATUS,
  AddressFacts,
  BIZAWAY_PARTNER_NAME,
  BundleFacts,
  CampaignFacts,
  ClaimFacts,
  CompensationSettingsFacts,
  ContractFacts,
  DIRECT_FERRIES_PARTNER_NAME,
  ExternalClaimFacts,
  FlightFacts,
  FlightStatusFacts,
  JourneyFacts,
  JsonLogicSentencesFacts,
  MAX_QUOTE_EXPIRATION_DURATION_IN_DAYS,
  NoCoefficientCompensationSettingForCurrency,
  PARTNERS,
  PARTNER_IDS_WITH_CUMULATIVE_CLAIMS_ON_ANNUAL_SUBSCRIPTIONS,
  ProductAttachmentFacts,
  ProductFacts,
  ProductPricingOverviewFacts,
  SEYNA_EXPORTABLE_BINDERS,
  STRIPE_PAYMENT_INTENT_STATUS_TO_SUBSCRIPTION_PAYMENT_STATUS,
  SegmentFacts,
  SeynaBinderFacts,
  StayFacts,
  SubscriptionFacts,
  SubscriptionPaymentFacts,
  TaxesCalculatorService,
  TripFacts,
  Wakam,
  calculatePremiumAsPercentageOfBookingPrice,
  calculateRetailPriceAsFixedAmount,
  computeBaseCompensation,
  computeBattlefaceFacts,
  computeConnectionFacts,
  computePricingFactors,
  computeTicketRefundFactors,
  findLongestGapIndex,
  getDestinationSegment,
  i18nAirportCountriesTranslationLanguageCodes,
  i18nEmailTemplatesLanguageTags,
  isRoundTrip,
  selectDefaultCurrencySettings
};
//# sourceMappingURL=index.js.map